/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-02 11:55:37
 * @LastEditors: Aragorn houpengxu@qq.com
 * @LastEditTime: 2022-09-13 15:44:05
 * @Description: file content
 */
/**
 * Created by pengxu on 2017/6/23.
 * 180814二次授权
 */
import Canvastoimg from "wtc-canvastoimg";
/**
 * config
 */
window.cfg = {
  isLoc: location.href.indexOf("localhost") > -1 ? true : false,
  isTest: (location.host.indexOf("qmyx.") > -1 || location.host.indexOf("sjzstest.") > -1 || location.host.indexOf("rstest.") > -1 || location.host.indexOf("cartest.") > -1) ? true : false,
  helpShowWx: 0,
  apihost: /\.(com|net|org|cn)$/i.test(location.hostname)
    ? (location.hostname.substring(0, location.hostname.indexOf(".")) + ".ttrushi.com") : 'xyzsplf.ttrushi.com',
  subdomian: ''
}
cfg.subdomian = cfg.apihost.substring(0, cfg.apihost.indexOf("."));
if (cfg.isLoc) {

}
window.api = {
  h5: location.protocol + "//" + cfg.apihost + "/qc-webapp/h5count.do?",
  wx: location.protocol + "//" + cfg.apihost + "/qc-webapp/wxapi.do",
  wxQcwebapp: location.protocol + "//" + cfg.apihost + "/qc-webapp"
}

if (cfg.isTest) {
  yqAnalytics.init({
    env: "test",
    appId: "b7b0f945a5fd4ab197eb77f4743c09aa",
  });
} else {
  yqAnalytics.init({
    appId: "82d2ff334d404f6c914b4fe8e68f4008",
  });
}

yqAnalytics.clientLogSetId(4)

/**
 * defined function
 */
window.wj = {
  clientW: document.documentElement.clientWidth,
  clientH: document.documentElement.clientHeight,
  subDomain: cfg.apihost.split('.')[0],
  qs: function (name, isDecodeURI) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      if (isDecodeURI)
        return decodeURI(r[2]);
      return r[2];
    }
    return null;
  },
  qsUrl: function (parm, url) {
    var arr = url.split("?");

    if (arr.length > 1) {

      var arrparm = arr[1].split("&");

      var a;

      for (var i = 0; i < arrparm.length; i++) {

        a = arrparm[i].split("=");

        if (a != null && a[0] == parm) {

          return a[1];

        };

      }

    } else {

      return "";

    }
  },
  browser: {
    info: navigator.appVersion,
    versions: function () {
      var u = navigator.userAgent, app = navigator.appVersion;
      return {
        trident: u.indexOf('Trident') > -1,
        presto: u.indexOf('Presto') > -1,
        webKit: u.indexOf('AppleWebKit') > -1,
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/),
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1,
        iPad: u.indexOf('iPad') > -1,
        webApp: u.indexOf('Safari') == -1,
        wxGroup: u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger',
        wx: u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger' && u.match(/wxwork/i) != 'wxwork',
        dy: u.toLowerCase().match(/toutiaomicroapp/i) == 'toutiaomicroapp',
        wxwork: u.match(/wxwork/i) == 'wxwork'
      };
    }()
  },
  getQueryObj() {
    var url = location.href;
    if (url && url.indexOf("#wechat_redirect")) {
      url = url.replace(/#wechat_redirect/g, "");
    }
    var tmpObj = {};
    var tmpArr = url.split("?");
    if (tmpArr.length == 2) {
      var urlParam = tmpArr[1];
      var tmpArr1 = urlParam.split('&');
      tmpArr1 = tmpArr1.map(function (e) {
        if (e) {
          tmpObj[e.split('=')[0]] = e.split('=')[1];
        }
      })
    }
    return tmpObj;
  },
  isMobileNumber: function (mobile) {
    var b1 = /^1[3-9]\d{9}$/.test(String(mobile).replace(/^0+/g, ''));
    var b2 = /^0\d{2,3}-?\d{7,8}$/.test(mobile);
    var b3 = false;
    if (returnCitySN && returnCitySN.cname) {
      if (!/[\u4e00-\u9fa5]+/.test(returnCitySN.cname)) {
        b3 = /^[' '|+|-|a|\d]{5,20}$/.test(mobile);
      }
    }
    return b1 || b2 || b3;
  },
  isNumber: function (str) {
    return /^[1-9]+[0-9]*]*$/.test(str);
  },
  loadImgs: function (urls, progressCallback, completeCallback) {
    var myInterVal = null;
    var imgs = [], index = 0, _load = function _load() {
      var img = new Image;
      img.src = urls[index], img.onload = function () {
        imgs.push(img);
        if (progressCallback) {
          progressCallback();
        }
        index++;
        if (index / urls.length == 1) {
          completeCallback();
        } else {
          _load();
        }
      }
    };
    _load();
  },
  loadAudio: function (src, callback) {
    var audio = new Audio(src);
    audio.onloadedmetadata = callback;
    audio.src = src;
  },
  cookie: {
    set: function (key, val, second, domain) {//设置cookie方法，秒过期
      var date = new Date(); //获取当前时间
      date.setTime(date.getTime() + second * 1000); //格式化为cookie识别的时间
      var cookieVal = key + "=" + val + ";path=/;expires=" + date.toGMTString() + (domain ? (";domain=" + domain) : "");  //设置cookie
      document.cookie = cookieVal;
    },
    get: function (key) {//获取cookie方法
      /*获取cookie参数*/
      var getCookie = document.cookie.replace(/[ ]/g, "");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
      var arrCookie = getCookie.split(";")  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
      var tips = "";  //声明变量tips
      for (var i = 0; i < arrCookie.length; i++) {   //使用for循环查找cookie中的tips变量
        var arr = arrCookie[i].split("=");   //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
        if (key == arr[0]) {  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
          tips = arr[1];   //将cookie的值赋给变量tips
          break;   //终止for循环遍历
        }
      }
      return tips;
    },
    delete: function (key) { //删除cookie方法
      var date = new Date(); //获取当前时间
      date.setTime(date.getTime() - 10000); //将date设置为过去的时间
      document.cookie = key + "=v; expires =" + date.toGMTString();//设置cookie
    }
  },
  clientInfo: (function () {
    var attrs = [
      "appCodeName"
      , "appName"
      , "appVersion"
      , "cookieEnabled"
      , "language"
      , "platform"
      , "product"
      , "vendor"
    ];
    var str = "";
    attrs.forEach(function (e, i) {
      str += e + ":" + navigator[e] + ";";
    })
    return str;
  })(),
  changeTitle: function (title) {
    if (wj.browser.versions.wx && wj.browser.versions.ios) {
      var $body = $('body');
      document.title = title;
      // hack在微信等webview中无法修改document.title的情况
      var $iframe = $('<iframe style="display:none;opacity: 0;" src=""></iframe>');
      $iframe.on('load', function () {
        setTimeout(function () {
          $iframe.off('load').remove();
        }, 0);
      }).appendTo($body);
    } else {
      document.title = title;
    }
  },
  addSpreadParams(url) {
    let params = {}
    if (myTemp.refereeopenid) {
      params.refereeopenid = myTemp.refereeopenid;
    }
    if (myTemp.rscuid) {
      params.rscuid = myTemp.rscuid;
    }
    return this.addUrlParamFromObj(url, params);
  },
  openUrl: function (url) {
    location.href = this.addSpreadParams(url);
  },
  getismp: function (fun) {
    if (location.host.indexOf("localhost") > -1 && location.href.indexOf("ismp=1") > -1) {
      fun(true);
    } else {
      if (!wx.miniProgram) return;
      wx.miniProgram.getEnv(function (res) {
        fun(res.miniprogram);
      });
    }
  },
  //内嵌在小程序中的跳转，需要在页面引入wxjssdk1.32+
  mp: {
    nav: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.navigateTo({ url: url });
    },
    navBack: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.navigateBack({ url: url });
    },
    switch: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.switchTab({ url: url });
    },
    rel: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.reLaunch({ url: url });
    },
    red: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.redirectTo({ url: url });
    }
  },
  /**
  * 对象转换url参数
  */
  objToUrlParam(obj) {
    let urlParam = '';
    Object.keys(obj).forEach(function (e) {
      urlParam += `${e}=${obj[e]}&`
    })
    if (urlParam.length > 0) {
      urlParam = urlParam.substring(0, urlParam.length - 1);
    }
    return urlParam;
  },
  /**
   * url参数转换对象
   * @param {*} urlParam
   */
  urlParamToObj(urlParam) {
    // a=1&b=2
    let tmpObj = {};
    let tmpArr = urlParam.split('&');
    tmpArr = tmpArr.map(function (e) {
      tmpObj[e.split('=')[0]] = e.split('=')[1];
    })
    return tmpObj;
  },

  /**
   * 从url上获取参数
   */
  getParamFromUrl(url) {
    if (url.indexOf("#wechat_redirect") > -1) {
      url = url.replace("#wechat_redirect", "");
    }
    let tmpObj = {};
    let tmpArr = url.split("?");
    if (tmpArr.length == 2) {
      let urlParam = tmpArr[1];
      let tmpArr1 = urlParam.split('&');
      tmpArr1 = tmpArr1.map(function (e) {
        tmpObj[e.split('=')[0]] = e.split('=')[1];
      })
    }
    return tmpObj;
  },
  /*
   * @Description: 获取不带参数的URL
   * @param:
   * @return:
   */
  getUrlRemoveParams(url) {
    if (url.indexOf("?") != -1) {
      url = url.split("?")[0];
      return url;
    }
    return url;
  },
  // 给url添加参数 通过对象
  addUrlParamFromObj(url, obj) {
    let newUrl = this.getUrlRemoveParams(url);
    let newUrlParam = this.getParamFromUrl(url);
    newUrlParam = {
      ...newUrlParam,
      ...obj
    };
    let newUrlParamStr = this.objToUrlParam(newUrlParam);
    if (newUrlParamStr) {
      return newUrl + '?' + newUrlParamStr;
    }
    return newUrl;
  },

  /**
   * 获取域名根据链接
   * @param {*} url
   */
  getHostFromUrl(url) {
    if (url) {
      let domain = url.split('/');
      let host = "";
      if (domain[2] && (this.isWebUrl(domain[2]))) {
        host = domain[2];
      }
      return host;
    }
    return "";
  },
  /**
   * 是否是网址
   * @param {*} url
   */
  isWebUrl(url) {
    return /^(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/.test(
      url
    );
  },
  getNameFromUrl(url) {
    let arr = wj.getUrlRemoveParams(url).split("/");
    return arr[arr.length - 1];
  },
  getUserInfo: function (callback, openid) {
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "action": "/global/User/getUserInfo",
          "requestParam": {
            openid: openid
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        console.log("/global/User/getUserInfo", data);
        if (callback) callback(data);
      }
    });
  },
  sendCommonTmpMsg(postObj, callback) {
    $.ajax({
      type: "GET",
      url: api.wx,
      async: true,
      data: {
        j: JSON.stringify({
          "action": "/global/Wxmsg/sendCommonTmpMsg",
          "requestParam": postObj,
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        if (callback) callback(data);
      }
    });
  },
  getFansInfo(callback, openid) {
    // 获取销售微信号
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "action": "/hb/HbUserAction/fansInfo",
          "requestParam": {
            obj: {
              openid: openid
            }
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        console.log(111, 'tp100', 'getFansInfo', data);
        if (callback) callback(data);
      }
    });
  },
  isObject: function (p) {
    return Object.prototype.toString.call(p) === "[object Object]"
  },
  getGuid: function () {
    let guid = "";
    for (var i = 1; i <= 32; i++) {
      var n = Math.floor(Math.random() * 16.0).toString(16);
      guid += n;
      if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
        guid += "";
    }
    return guid;
  },
  clientLog: {
    info() {
      this.clientLogFun(1, arguments)
    },
    warn() {
      this.clientLogFun(2, arguments)
    },
    error() {
      this.clientLogFun(3, arguments)
    },
    clientLogFun() {
      if (cfg.subdomian != 'qmyx') {
        return;
      }
      let filterMsg = '';
      let content = '';
      if (arguments[1].length == 0) {

      } else if (arguments[1].length == 1) {
        if (Object.prototype.toString.call(arguments[1][0]) === "[object String]") {
          filterMsg = arguments[1][0];
        }
      } else if (arguments[1].length == 2) {
        if (Object.prototype.toString.call(arguments[1][0]) === "[object String]") {
          filterMsg = arguments[1][0];
        }
        content = arguments[1][1];
        if (Object.prototype.toString.call(content) === "[object Object]" || Object.prototype.toString.call(content) === "[object Array]") {
          content = JSON.stringify(content);
        } else if (Object.prototype.toString.call(content) === "[object Null]") {
          content = 'Null';
        } else if (Object.prototype.toString.call(content) === "[object Undefined]") {
          content = 'Undefined';
        } else if (Object.prototype.toString.call(content) === "[object String]" || Object.prototype.toString.call(content) === "[object Number]") {

        } else {
          content = '';
        }
      } else if (arguments[1].length > 2) {

        if (Object.prototype.toString.call(arguments[1][0]) === "[object String]") {
          filterMsg = arguments[1][0];
        }
        content = []
        for (let index = 1; index < arguments[1].length; index++) {
          let element = arguments[1][index];
          if (Object.prototype.toString.call(element) === "[object Object]" || Object.prototype.toString.call(element) === "[object Array]") {
            element = JSON.stringify(element);
          } else if (Object.prototype.toString.call(element) === "[object Null]") {
            element = 'Null';
          } else if (Object.prototype.toString.call(element) === "[object Undefined]") {
            element = 'Undefined';
          } else if (Object.prototype.toString.call(element) === "[object String]" || Object.prototype.toString.call(element) === "[object Number]") {

          } else {
            element = '';
          }
          content.push(element);
        }
        content = JSON.stringify(content);
      }

      $.ajax({
        type: "POST",
        url: "https://log.yqyuntech.com/clientLog",
        async: false,
        data: {
          "repositoryId": 4,
          "levelId": arguments[0],
          "showId": window.myTemp.guid || '',
          "userId": window.myTemp.openid || '',
          "filterMsg": filterMsg,
          "content": content,
          "clientTime": new Date().getTime()
        },
        success: function (data) {
        }
      });
    }
  },
  getStrBlen(str) {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
        len += 2;
      } else {
        len++;
      }
    }
    return len;
  },
  loadJS(url, success) {
    let domScript = document.createElement('script');
    domScript.src = url;
    success = success || function () { };
    domScript.onload = domScript.onreadystatechange = function () {
      if (!this.readyState || 'loaded' === this.readyState || 'complete' === this.readyState) {
        success();
        this.onload = this.onreadystatechange = null;
        this.parentNode.removeChild(this);
      }
    }
    document.getElementsByTagName('head')[0].appendChild(domScript);
  }
};
/**
 * loading
 */
window.myTemp = {
  audio: null,//音乐对象
  arrSrc: [],//图片列表
  arrSrcMyServer: [],//本地WebServer上的图片进行预加载
  guid: "",
  openid: "",
  appid: "",
  refereeopenid: "",
  bottomBtnCount: 0,
  isRecordIng: 0,
  receiveMsgOpenId: "",//接收消息人openid
  sendImgBaseData: "",
  imgFaceCut: null,
  oldOriginalUrl: "",
  consultingLink: "",//咨询链接
  isAlreadyAfterActIpGetConsultingLink: false,//是否在act=ip之后请求了获取聊天对象
  isGetUpUserMobile: false,//是否请求获取过了上级手机号
  upUserMobile: "",//上级手机号
  share_api: "",
  psn: "",
  haveuserinfo: 0,//是否有用户信息
  userInfo: {},
  cardInfo: {},
  isSale: false,
  cookieKeys: {
    beforeAuthUrl: 'beforeAuthUrl_tp1'
  },
  isQuestionnaire: false,//是否内嵌的是问卷
  appMark: "crm",
  qwQrCodeUrl: "",//企微二维码
  qwQrCodePoster: "",//企微二维码海报
  cardFansInfo: {},
  photoRewardConfig: {},//晒照配置
  ipv6: '',
};
window.myPageData = {};
myPageData.PageId = wj.qs("id");
// if (wj.qs("participateid")) {
//   wj.cookie.set("participateid", wj.qs("participateid"), 60 * 10);
// }
// if (wj.qs("refereeopenid")) {
//   wj.cookie.set("refereeopenid", wj.qs("refereeopenid"), 60 * 10);
// } else {
//   if (location.href.indexOf("passport") > -1 && wj.qs("openid") > -1 && wj.qs("signature") > -1) {

//   } else {
//     wj.cookie.delete("refereeopenid");
//   }
// }
// if (wj.qs("processinstanceid")) {
//   wj.cookie.set("processinstanceid" + myPageData.PageId, wj.qs("processinstanceid"), 60 * 10);
// }
// if (wj.cookie.get("processinstanceid" + myPageData.PageId)) {
//   myTemp.processinstanceid = wj.cookie.get("processinstanceid" + myPageData.PageId);
// }
// if (wj.qs("psn")) {
//   wj.cookie.set("psn" + myPageData.PageId, wj.qs("psn"), 60 * 10);
// }
// if (wj.cookie.get("psn" + myPageData.PageId)) {
//   myTemp.psn = wj.cookie.get("psn" + myPageData.PageId);
// }
// if (wj.qs("wc")) {
//   wj.cookie.set("weichuangqs", wj.qs("wc"), 60 * 10);
// }
// var qsEntry = wj.qs("entry");
// if (qsEntry) {
//   wj.cookie.set("entry" + myPageData.PageId, qsEntry, 60 * 10);
// } else {
//   qsEntry = wj.cookie.get("entry" + myPageData.PageId);
// }
// var qsT9id = wj.qs("t9id");
// if (qsT9id) {
//   wj.cookie.set("t9id" + myPageData.PageId, qsT9id, 60 * 10);
// } else {
//   qsT9id = wj.cookie.get("t9id" + myPageData.PageId);
// }
// var qsT9psn = wj.qs("t9psn");
// if (qsT9psn) {
//   wj.cookie.set("t9psn" + myPageData.PageId, qsT9psn, 60 * 10);
// } else {
//   qsT9psn = wj.cookie.get("t9psn" + myPageData.PageId);
// }

// var qsHomeUrl = wj.qs("homeurl");
// if (qsHomeUrl) {
//   wj.cookie.set("homeurl" + myPageData.PageId, qsHomeUrl, 60 * 10);
// } else {
//   qsHomeUrl = wj.cookie.get("homeurl" + myPageData.PageId);
// }
// var qsXcxuid = wj.qs("xcxuid");
// var qsXcxappid = wj.qs("xcxappid");
// var qsXcxprojectid = wj.qs("xcxprojectid");
// if (qsXcxuid && qsXcxappid && qsXcxprojectid) {
//   wj.cookie.set("xcxuid" + myPageData.PageId, qsXcxuid, 60 * 10);
//   wj.cookie.set("xcxappid" + myPageData.PageId, qsXcxappid, 60 * 10);
//   wj.cookie.set("xcxprojectid" + myPageData.PageId, qsXcxprojectid, 60 * 10);
// } else {
//   qsXcxuid = wj.cookie.get("xcxuid" + myPageData.PageId);
//   qsXcxappid = wj.cookie.get("xcxappid" + myPageData.PageId);
//   qsXcxprojectid = wj.cookie.get("xcxprojectid" + myPageData.PageId);
// }
// var qsPurephonenumber = wj.qs("purephonenumber");
// if (qsPurephonenumber) {
//   wj.cookie.set("purephonenumber" + myPageData.PageId, qsPurephonenumber, 60 * 10);
// } else {
//   qsPurephonenumber = wj.cookie.get("purephonenumber" + myPageData.PageId);
// }
// var qsXcxnickname = wj.qs("xcxnickname");
// if (qsXcxnickname) {
//   wj.cookie.set("xcxnickname" + myPageData.PageId, qsXcxnickname, 60 * 10);
// } else {
//   qsXcxnickname = wj.cookie.get("xcxnickname" + myPageData.PageId);
// }
// var qsXcxheadimg = wj.qs("xcxheadimg");
// if (qsXcxheadimg) {
//   wj.cookie.set("xcxheadimg" + myPageData.PageId, qsXcxheadimg, 60 * 10);
// } else {
//   qsXcxheadimg = wj.cookie.get("xcxheadimg" + myPageData.PageId);
// }
// var qsXcxcountry = wj.qs("xcxcountry");
// if (qsXcxcountry) {
//   wj.cookie.set("xcxcountry" + myPageData.PageId, qsXcxcountry, 60 * 10);
// } else {
//   qsXcxcountry = wj.cookie.get("xcxcountry" + myPageData.PageId);
// }
// var qsXcxprovince = wj.qs("xcxprovince");
// if (qsXcxprovince) {
//   wj.cookie.set("xcxprovince" + myPageData.PageId, qsXcxprovince, 60 * 10);
// } else {
//   qsXcxprovince = wj.cookie.get("xcxprovince" + myPageData.PageId);
// }
// var qsXcxcity = wj.qs("xcxcity");
// if (qsXcxcity) {
//   wj.cookie.set("xcxcity" + myPageData.PageId, qsXcxcity, 60 * 10);
// } else {
//   qsXcxcity = wj.cookie.get("xcxcity" + myPageData.PageId);
// }
// JSON.stringify 格式
// var qsExtpar = wj.qs("extpar");
// if (qsExtpar) {
//   wj.cookie.set("extpar" + myPageData.PageId, qsExtpar, 60 * 10);
// } else {
//   qsExtpar = wj.cookie.get("extpar" + myPageData.PageId);
// }

// var qsRscuid = wj.qs("rscuid");
// if (qsRscuid) {
//   wj.cookie.set("rscuid" + myPageData.PageId, qsRscuid, 60 * 10);
// } else {
//   qsRscuid = wj.cookie.get("rscuid" + myPageData.PageId);
// }
// myTemp.rscuid = qsRscuid;

// var qsVrfid = wj.qs("vrfid");
// if (qsVrfid) {
//   wj.cookie.set("vrfid" + myPageData.PageId, qsVrfid, 60 * 10);
// } else {
//   qsVrfid = wj.cookie.get("vrfid" + myPageData.PageId);
// }
// myTemp.vrfid = qsVrfid;

(function () {
  let urlParam = wj.getParamFromUrl(location.href);
  myTemp.participateid = urlParam.participateid;
  myTemp.refereeopenid = urlParam.refereeopenid;
  myTemp.processinstanceid = urlParam.processinstanceid;
  myTemp.psn = urlParam.psn;
  myTemp.weichuangqs = urlParam.wc;
  myTemp.entry = urlParam.entry;
  myTemp.t9id = urlParam.t9id;
  myTemp.t9psn = urlParam.t9psn;
  myTemp.homeurl = urlParam.homeurl;
  myTemp.xcxuid = urlParam.xcxuid;
  myTemp.xcxappid = urlParam.xcxappid;
  myTemp.xcxprojectid = urlParam.xcxprojectid;
  myTemp.purephonenumber = urlParam.purephonenumber;
  myTemp.xcxnickname = urlParam.xcxnickname;
  myTemp.xcxheadimg = urlParam.xcxheadimg;
  myTemp.xcxcountry = urlParam.xcxcountry;
  myTemp.xcxprovince = urlParam.xcxprovince;
  myTemp.xcxcity = urlParam.xcxcity;
  myTemp.extpar = urlParam.extpar;
  myTemp.rscuid = urlParam.rscuid;
  myTemp.vrfid = urlParam.vrfid;

})();
function firstAuth() {
  var j = wj.qs("j");
  if (j) {
    var data = decodeURIComponent(j);
    data = JSON.parse(data);
    myTemp.appid = data.appid;
    myTemp.openid = data.openid;
    myTemp.passport = data.passport;
    var authObj = {
      appid: data.appid,
      openid: data.openid,
      passport: data.passport
    }
    if (location.href.indexOf('keppelss.') > 0) {
      wj.cookie.set("openid", authObj.openid, 1 * 60 * 60 * 24, location.host);
      wj.cookie.set("passport", authObj.passport, 1 * 60 * 60 * 24, location.host);
    }
    wj.cookie.set("pack1_20190416", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    if (authObj && authObj.openid) {
      wj.cookie.set("openid", authObj.openid, 1 * 60 * 60 * 24 * 365);
    }
    if (authObj && authObj.passport) {
      wj.cookie.set("passport", authObj.passport, 1 * 60 * 60 * 24 * 365);
    }
    wj.cookie.set("pack1_20190416_first", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    secondAuthGetUrl();
  } else {
    //静默授权
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "url": location.href,
          "action": "getConfig",
          "requestParam": {}
        }),
        t: 6
      },
      success: function (data) {
        if (data && data.obj) {
          if (data.obj.share_api) {
            wj.cookie.set("share_api", data.obj.share_api, 60 * 10);
          }
          let authCallBackUrl = location.href.replace("#wechat_redirect", "");
          let urlParam = wj.getParamFromUrl(authCallBackUrl);
          delete urlParam.xcxcountry;
          delete urlParam.xcxprovince;
          delete urlParam.xcxcity;
          delete urlParam.extpar;
          authCallBackUrl = wj.addUrlParamFromObj(wj.getUrlRemoveParams(authCallBackUrl), urlParam);
          let authUrl = `${location.protocol}//${location.host}/qc-webapp/wxapi.do?appid=${data.obj.appid}&scope=snsapi_base&wxauthcburl=${encodeURIComponent(authCallBackUrl)}`;
          location.href = authUrl;
          return false;
        }

      }
    });
  }

}

function secondAuthGetUrl() {
  // $.ajax({
  //     type: "GET",
  //     async: false,
  //     url: api.wx,
  //     data: {
  //         j: JSON.stringify({
  //             "action": "/hb/HbH5Action/getPageInfo",
  //             "requestParam": {
  //                 obj: {
  //                     "id": myPageData.PageId
  //                 }
  //             },
  //             "openid": myTemp.openid,
  //             "passport": myTemp.passport,
  //             "url": location.href
  //         })
  //     },
  //     success: function (data) {
  //         if (data && data.obj && data.obj.PageData) {
  //             myPageData = JSON.parse(decodeURIComponent(data.obj.PageData.replace(/[+]/g, "%20")));
  //             wj.changeTitle(myPageData.BrowserTabTitle);

  //         } else {
  //             // alert("H5内容获取失败！")
  //         }
  //     }
  // });
  getPageInfo();
  if (myTemp.haveuserinfo) {
    var authObj = JSON.parse(wj.cookie.get("pack1_20190416_first"));
    wj.cookie.set("pack1_20190416_second", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    let beforeAuthUrl = wj.cookie.get(myTemp.cookieKeys.beforeAuthUrl)
    if (beforeAuthUrl) {
      wj.cookie.delete(myTemp.cookieKeys.beforeAuthUrl);
      location.href = decodeURIComponent(beforeAuthUrl);
    }
  } else {
    //有二次授权的话进行二次授权
    if (myPageData.Isrushiauth && myPageData.Isrushiauth == 1) {
      //如是授权
      var appid = "wxf1efeb9b9d6f6f06";
      var host = "rushi.rushinews.com";
      var scope = "snsapi_userinfo";
      var arrUrl = location.href.split("/");
      var strPage = arrUrl[arrUrl.length - 1];
      let strState = encodeURIComponent(`${location.protocol}//${location.host}/h5/${strPage}`);
      var authUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=http://" + host + "/qc-webapp/oauthcallback.do&response_type=code&scope=" + scope + "&state=" + strState + "#wechat_redirect";
      location.replace(authUrl)
    }
    else if (myPageData.Isrushiauth && myPageData.Isrushiauth == 2) {
      // 内嵌小程序不再进行H5微信用户信息授权
      wj.getismp(function (ismp) {
        if (!ismp) {
          //本公众号网页授权
          $.ajax({
            type: "GET",
            url: api.wx,
            async: false,
            data: {
              j: JSON.stringify({
                "url": location.href,
                "action": "getConfig",
                "requestParam": {}
              }),
              t: 6
            },
            success: function (data) {
              if (data && data.obj) {
                if (data.obj.share_api) {
                  wj.cookie.set("share_api", data.obj.share_api, 60 * 10);
                }
                let authCallBackUrl = location.href.replace("#wechat_redirect", "");
                let urlParam = wj.getParamFromUrl(authCallBackUrl);
                delete urlParam.xcxcountry;
                delete urlParam.xcxprovince;
                delete urlParam.xcxcity;
                authCallBackUrl = wj.addUrlParamFromObj(wj.getUrlRemoveParams(authCallBackUrl), urlParam);
                let authUrl = `${location.protocol}//${location.host}/qc-webapp/wxapi.do?appid=${data.obj.appid}&scope=snsapi_userinfo&wxauthcburl=${encodeURIComponent(authCallBackUrl)}`;
                location.href = authUrl;
                return false;
              }
            }
          });
        }
      })
    }
  }
}

function secondAuth() {
  var j = wj.qs("j");
  if (j) {
    //回调
    var data = decodeURIComponent(j);
    data = JSON.parse(data);
    myTemp.appid = data.appid;
    myTemp.openid = data.openid;
    myTemp.passport = data.passport;
    var authObj = {
      appid: data.appid,
      openid: data.openid,
      passport: data.passport
    }
    wj.cookie.set("pack1_20190416", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    wj.cookie.set("pack1_20190416_second", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    let beforeAuthUrl = wj.cookie.get(myTemp.cookieKeys.beforeAuthUrl)
    if (beforeAuthUrl) {
      wj.cookie.delete(myTemp.cookieKeys.beforeAuthUrl);
      location.href = decodeURIComponent(beforeAuthUrl);
    } else {
      getPageInfo();
    }
  }
}
// myTemp.refereeopenid = wj.cookie.get("refereeopenid");
var isFirstAuth = '', isSecondAuth = '';

// 如果是在企微打开就替换成企微的路径
if (wj.browser.versions.wxwork && !cfg.isLoc) {
  // location.replace(location.href.replace("/h5/", "/qwh5/"));
  let url = location.href.replace("/h5/", "/qwh5/")
  url = wj.addUrlParamFromObj(url, {
    gzhDomain: location.host
  })
  location.replace(url);
} else {
  // 强行定制不授权和设置固定openid 原圈云 富力
  if (myPageData.PageId == 168868 || myPageData.PageId == 169731 || myPageData.PageId == 174123
    || myPageData.PageId == 174625 || myPageData.PageId == 174627) {
    myTemp.openid = "om3fus_cBy12pjP0kqaWLykUDXE4";
    myTemp.passport = "6db216eb6af85373315d32875a3af2a2";
    getPageInfo();
  } else if (location.href.indexOf("noguide=1") > -1) {
    myTemp.openid = "oL2VdtybujU4QjemHdwSNOnikI8E";
    myTemp.passport = "807f860161cae2b6b6ec229ff3d4f5bd";
    getPageInfo();
  } else {
    if (wj.browser.versions.wx) {
      let urlParams = wj.getParamFromUrl(location.href);
      if (urlParams.openid && urlParams.passport) {
        myTemp.openid = urlParams.openid;
        myTemp.passport = urlParams.passport;
        getPageInfo();
      } else {
        isFirstAuth = wj.cookie.get("pack1_20190416_first");
        isSecondAuth = wj.cookie.get("pack1_20190416_second");
        if (isFirstAuth) {
          var authObj = JSON.parse(wj.cookie.get("pack1_20190416_first"));
          myTemp.appid = authObj.appid;
          myTemp.openid = authObj.openid;
          myTemp.passport = authObj.passport;
          if (!isSecondAuth) {
            secondAuth();
            // 两步授权取消第二步授权，下次继续授权。
            isSecondAuth = wj.cookie.get("pack1_20190416_second");
            if (!isSecondAuth) {
              secondAuthGetUrl();
            }
          } else {
            getPageInfo();
          }
        } else {
          // 存授权之前的链接
          if (!urlParams.j) {
            wj.cookie.set(myTemp.cookieKeys.beforeAuthUrl, encodeURIComponent(location.href));
          }
          firstAuth();
        }
      }
    } else {
      if (cfg.isLoc) {
        var fake = wj.qs("fake")
        switch (fake) {
          case "xyzsplf_may":
            myTemp.openid = "ogii35pnVi8s8FGa-V3_FP9n6GrI";
            myTemp.passport = "356058c060fee076363a36b8801e112c";
            break;
          case "xyzsplf_hope":
            myTemp.openid = "ogii35vUuvqUrE-D5YaTX7gwWBp0";
            myTemp.passport = "7471e0f47a2c6a9beb140b529c5eb9c4";
            break;
          case "dljdpp_hope":
            myTemp.openid = "oLycot5zfapZgo3kVdRoE-62ionk";
            myTemp.passport = "4ccb0c8f9d644e29e9dc594fd1c8931a";
            break;
          case "dhbhyh_may":
            myTemp.openid = "oENw45soRMI_bu3rfXxcxhpOerlQ";
            myTemp.passport = "5a0a6c302d71ed8af7fd44149ea16ba3";
            break;
          case "dhbhyh_hope":
            myTemp.openid = "oENw45gHttq7bkX858PQ-J9OQGYY";
            myTemp.passport = "b4c5f2f72f80724d89f23b384fbcc107";
            break;
          case "rushi_hope":
            myTemp.openid = "ooSW7wCba7oABRNDGptiL95zK6Ho";
            myTemp.passport = "eceb50439b45126f2782d627809c1095";
            break;
          case "zhsd_hope":
            myTemp.openid = "oL2VdtybujU4QjemHdwSNOnikI8E";
            myTemp.passport = "807f860161cae2b6b6ec229ff3d4f5bd";
            break;
          case "qmyx_hope":
            myTemp.openid = "oj3y9wGThdLqhn0bZWOj7DeO2Tww";
            myTemp.passport = "b4de197ab7b03e9d014116821e90d54f";
            break;
          case "thl":
            myTemp.openid = "oj3y9wC53_RrnMv-s9GdYR1ZtoRE";
            myTemp.passport = "1afc14cf3ab0fe8a78196d3445d76f0a";
            break;
          case "lyx":
            myTemp.openid = "oj3y9wNKtjyOHOTUL-O8EXSFhjL0";
            myTemp.passport = "1bb1e9ef7cea60bf6f6ffa1bfc3d0f8c";
            break;
          case "gg":
            myTemp.openid = 'oj3y9wA4Mys0Jl0w3xmPteu4xGAs';
            myTemp.passport = '9bbf3ee7469b647ca65d51361e1eb28d'
            break;
          case "zhsd_lyx":
            myTemp.openid = 'oL2VdtxhggACbN7aHUhk69OjTIVY';
            myTemp.passport = '81efbdf330782e509a09e4ef12da6394';
            break;
          case "lianshi_hope":
            myTemp.openid = 'oAA4e0yNg7mFL_aEAD9J2Ig8XoZo';
            myTemp.passport = 'f1f4567130c5d683b5e5ce184cb57e27';
            break;
          case "jisu_hope":
            myTemp.openid = 'oPg9r1WEa_1ikSKWlMeJonVwQHdQ';
            myTemp.passport = '70021c7e84e0da8787bab5eb3669590d';
            break;
          case "yqjisu_wagnzhaoyu":
            myTemp.openid = 'oPg9r1XOsQObgUNcQfiy0Pd0ILh4';
            myTemp.passport = 'f188b024f058b289dee8897080e729cc';
            break;
          default:
            myTemp.openid = 'oL2VdtxhggACbN7aHUhk69OjTIVY';
            myTemp.passport = '81efbdf330782e509a09e4ef12da6394';
            break;
        }
        getPageInfo();
      }
    }
  }
}

(function () {

  // 如果是在企微打开就替换成企微的路径
  if (wj.browser.versions.wxwork && !cfg.isLoc) {
    // location.replace(location.href.replace("/h5/", "/qwh5/"));
    let url = location.href.replace("/h5/", "/qwh5/")
    url = wj.addUrlParamFromObj(url, {
      gzhDomain: location.host
    })
    location.replace(url);
  } else {
    if (wj.browser.versions.wxGroup) {
      let urlParams = wj.getParamFromUrl(location.href);
      // 兼容企微转发的链接调整api路径
      if (wj.browser.versions.wx && urlParams.gzhSubDomain) {
        window.cfg.apihost = `${urlParams.gzhSubDomain}.ttrushi.com`;
        window.api = {
          h5: location.protocol + "//" + cfg.apihost + "/qc-webapp/h5count.do?",
          wx: location.protocol + "//" + cfg.apihost + "/qc-webapp/wxapi.do",
          wxQcwebapp: location.protocol + "//" + cfg.apihost + "/qc-webapp"
        }
      }
      // 如果是企微域名的链接，且在微信环境下
      if (wj.browser.versions.wx && urlParams.gzhDomain && (location.host == 'qywx.ruthus.com' || location.host == 'qyweb.gbtse.com')) {
        if (urlParams.openid) {
          delete urlParams.openid;
        }
        if (urlParams.passport) {
          delete urlParams.passport;
        }
        location.href = wj.addUrlParamFromObj(wj.getUrlRemoveParams(location.href).replace(location.host, urlParams.gzhDomain), urlParams);
      } else {
        if (urlParams.openid && urlParams.passport) {
          myTemp.openid = urlParams.openid;
          myTemp.passport = urlParams.passport;
        } else {
          // 授权一致性校验
          var isFirstAuth = wj.cookie.get("pack1_20190416_first");
          var isSecondAuth = wj.cookie.get("pack1_20190416_second");
          var authObj = wj.cookie.get("pack1_20190416");
          if ((isFirstAuth && isSecondAuth && authObj) || (isFirstAuth && authObj)) {
            isFirstAuth = JSON.parse(isFirstAuth);
            authObj = JSON.parse(authObj);
            if (isSecondAuth) {
              isSecondAuth = JSON.parse(isSecondAuth);
            } else {
              isSecondAuth = { openid: "" }
            }

            if ((isFirstAuth.openid == isSecondAuth.openid && isFirstAuth.openid == authObj.openid) || isFirstAuth.openid == authObj.openid) {

            } else {
              wj.cookie.delete("pack1_20190416_first");
              wj.cookie.delete("pack1_20190416_second");
              wj.cookie.delete("pack1_20190416");
              // var strUrl = location.href.split('?')[0];
              // strUrl += "?id=" + myPageData.PageId;
              // strUrl += "&psn=" + myTemp.psn;
              // if (wj.cookie.get("refereeopenid")) {
              //   myTemp.refereeopenid = wj.cookie.get("refereeopenid");
              //   strUrl += "&refereeopenid=" + myTemp.refereeopenid;
              // }
              // location.replace(strUrl)
              location.reload();
            }
          }
        }
      }
    }
  }

})();

// $.ajax({
//     type: "GET",
//     async: false,
//     url: api.wx,
//     data: {
//         j: JSON.stringify({
//             "action": "/hb/HbH5Action/getPageInfo",
//             "requestParam": {
//                 obj: {
//                     "id": myPageData.PageId
//                 }
//             },
//             "openid": myTemp.openid,
//             "passport": myTemp.passport,
//             "url": location.href
//         })
//     },
//     success: function (data) {
//         if (data && data.obj && data.obj.PageData) {
//             myPageData = JSON.parse(decodeURIComponent(data.obj.PageData.replace(/[+]/g, "%20")));
//             wj.changeTitle(myPageData.BrowserTabTitle);
//         } else {
//             // alert("H5内容获取失败！")
//         }
//     }
// });
function getPageInfo() {
  var dataObj = {
    "id": myPageData.PageId
  }
  if (myTemp.psn) {
    dataObj.psn = myTemp.psn;
  }
  $.ajax({
    type: "GET",
    async: false,
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbH5Action/getPageInfo",
        "requestParam": {
          obj: dataObj
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      console.log(111, 'getPageInfo', data)
      if (data) {
        myTemp.haveuserinfo = data.haveuserinfo;
        if (data.obj && data.obj.gzh_appid) {
          myTemp.appid = data.obj.gzh_appid;
        }
      }
      if (data && data.obj && data.obj.PageData) {
        myPageData = JSON.parse(decodeURIComponent(data.obj.PageData.replace(/[+]/g, "%20")));
        wj.changeTitle(myPageData.BrowserTabTitle);
        if (myPageData.OriginalUrl) {
          if (myPageData.OriginalUrl.indexOf('mqn.wxrsznkj.com') > -1 || myPageData.OriginalUrl.indexOf('mqndev.wxrsznkj.com') > -1) {
            myTemp.isQuestionnaire = true;
          }
        }
        myPageData.Other = {};
        Object.keys(data.obj).forEach(function (e) {
          if (e != "PageData") {
            myPageData.Other[e] = data.obj[e];
          }
        })
        myTemp.appid = myPageData.Other.gzh_appid;
        console.log("getPageInfo", JSON.parse(JSON.stringify(myPageData)));
      } else {
        // alert("H5内容获取失败！")
      }
    }

  });
}
if (wj.cookie.get("share_api")) {
  myTemp.share_api = wj.cookie.get("share_api");
}

$(function () {

  if (myPageData.PageId == 3675 || myPageData.PageId == 3679) {
    $(".music_img").addClass("hide");
  }
  if (false) {
    var viewportmeta = document.querySelector('meta[name="viewport"]');
    if (viewportmeta) {
      viewportmeta.content = 'width=device-width,initial-scale=0.5';
    }
    $(".music_img").addClass("hide");
  }
});
// if (wj.cookie.get("refereeopenid")) {
//   myTemp.refereeopenid = wj.cookie.get("refereeopenid");
// }
// if (wj.cookie.get("weichuangqs")) {
//   myTemp.weichuangqs = wj.cookie.get("weichuangqs");
// }
if (wj.browser.versions.wx || cfg.isLoc) {
  initWXJSSDK();
}
//是否是微创的h5
var tmpActId = "";
var tmpWid = "";
var tmpParticipateid = "";
if (myPageData && myPageData.Ispackmode && parseInt(myPageData.Ispackmode) == 2 && myTemp.openid) {
  if (location.href.startsWith("https:") && myPageData.OriginalUrl.startsWith("http:")) {
    myPageData.OriginalUrl = myPageData.OriginalUrl.replace("http:", "https:");
  }
  tmpActId = wj.qsUrl("id", myPageData.OriginalUrl);
  tmpWid = wj.qsUrl("wid", myPageData.OriginalUrl);
  tmpParticipateid = myTemp.participateid || 0;
  myTemp.oldOriginalUrl = myPageData.OriginalUrl;
  var requestParamData = {};
  if (myPageData.PageId == 3078 || myPageData.PageId == 3504) {
    //让微创页面在非微信环境下也能访问
    requestParamData = {
      openid: "ooSW7wCba7oABRNDGptiL95zK6Ho",
      "url": myPageData.OriginalUrl + "&participateid=" + parseInt(tmpParticipateid),
    }
  } else {
    // 直接跳转到微创页面 所需参数
    var tmpStr874 = `&tt=20201017&ptype=tp1&pageid=${myPageData.PageId || ''}&openid=${myTemp.openid || ''}&passport=${myTemp.passport || ''}&refereeopenid=${myTemp.refereeopenid || ''}&projectid=${myPageData.Pid || ''}&apihost=${cfg.apihost || ''}&host=${location.host || ''}`;
    if (myTemp.psn) {
      tmpStr874 += "&psn=" + myTemp.psn;
    }
    if (myPageData.PageId == 299200 || myPageData.PageId == 299218) {
      tmpStr874 += "&hideshare=1"
    }
    if (myTemp.share_api) {
      tmpStr874 += "&share_api=" + encodeURIComponent(myTemp.share_api);
    }
    var qsWc = myTemp.weichuangqs;
    if (qsWc) {
      qsWc = decodeURIComponent(qsWc);
      qsWc = JSON.parse(qsWc);
      qsWc = wj.objToUrlParam(qsWc);
      if (qsWc) {
        tmpStr874 += "&" + qsWc;
      }
      wj.cookie.delete("weichuangqs");
    }
    let url1226 = wj.addSpreadParams(myPageData.OriginalUrl + tmpStr874)
    requestParamData = {
      // "url": myPageData.OriginalUrl + "&participateid=" + parseInt(tmpParticipateid) + tmpStr874
      "url": url1226
    }
  }

  var insetPageUrlData = {
    openid: myTemp.openid,
    passport: myTemp.passport,
    "url": location.href,
    "action": "/wicre/WicreAction/insetPageUrl",
    "requestParam": requestParamData
  };
  console.log("insetPageUrl参数：", insetPageUrlData)
  $.ajax({
    type: "GET",
    url: api.wx,
    async: false,
    data: {
      j: JSON.stringify(insetPageUrlData),
      t: 6
    },
    success: function (data) {
      console.log("insetPageUrl结果：", data)
      if (data && data.obj) {
        console.log(111, '获取微创的链接', data)
        // 直接跳转到微创页面
        if (myPageData.PageId == 6892) {
          myPageData.Isredirect_oriurl = 1;
        }
        if (myPageData.Isredirect_oriurl && myPageData.Isredirect_oriurl == 1) {
          isFirstAuth = wj.cookie.get("pack1_20190416_first");
          isSecondAuth = wj.cookie.get("pack1_20190416_second");
          if ((wj.browser.versions.wx && ((myPageData.Isrushiauth && myPageData.Isrushiauth == 1 && isFirstAuth) ||
            (myPageData.Isrushiauth && myPageData.Isrushiauth == 2 && isSecondAuth))) || cfg.isLoc) {
            let urlParam = window.wj.getParamFromUrl(data.obj);
            console.log(111, '获取微创的链接参数', urlParam);
            console.log(111, '获取微创的链接参数url', decodeURIComponent(urlParam.url));
            // (urlParam.url && decodeURIComponent(urlParam.url).indexOf('/form/detail') > -1)
            if (myPageData.PageId == 63429) {
              console.log(1111, '获取微创的链接换成https', data.obj.replace(/http/g, "https"))
              location.href = data.obj.replace(/http/g, "https");
            } else {
              location.href = data.obj;
            }
            if (window.event && typeof window.event == "object") {
              window.event.returnValue = false;
            }
          }

        } else {
          if (myTemp.refereeopenid) {
            if (data.obj.indexOf('?') > -1) {
              myPageData.OriginalUrl = data.obj + '&from=' + myTemp.refereeopenid;
            } else {
              myPageData.OriginalUrl = data.obj + '?from=' + myTemp.refereeopenid;
            }

          } else {
            myPageData.OriginalUrl = data.obj;
          }
        }
      } else {
        myPageData.OriginalUrl = "";
      }
    }
  });
}



//特定跳转
if (location.href.indexOf("187.html") > -1 && wj.qs("target") == "question") {
  myPageData.Survey = "http://ddipctest.rushinews.com/web/ui/direction.html?page=rs1&classId=23079458611456&questionnaireId=23079458419200&tacheItemId=23079458615040";
  if (myPageData.Surveyext) {
    myPageData.Survey = myPageData.Surveyext;
  }
  myPageData.Survey = myPageData.Survey.replace("ddipctest", "wjpro");
  if (myPageData.Survey.indexOf(".html?") > -1) {
    myPageData.Survey = myPageData.Survey + "&";
  } else {
    myPageData.Survey = myPageData.Survey + "?";
  }
  myPageData.Survey += "appid=" + myTemp.appid + "&openid=" + myTemp.openid + "&pageid=" + myPageData.PageId + "&host=" + location.host + "&refereeopenid=" + myTemp.refereeopenid;
  location.href = myPageData.Survey;
  if (window.event && typeof window.event == "object") {
    window.event.returnValue = false;
  }
}

var tmpStr = ""
if (myPageData.OriginalUrl) {

  if (myPageData.Ispackmode && parseInt(myPageData.Ispackmode) == 2) {
    //微创
  } else if (myPageData.PageId == 3160 || myPageData.PageId == 3535) {
    myPageData.OriginalUrl = `http://${location.host}/activities/zhhf-questionsanswer/index.html?from=h5&openid=${myTemp.openid}&passport=${myTemp.passport}&flag=1&issubscribe=1&appid=${myTemp.appid}`;

  } else if (myPageData.PageId == 4108) {
    // 包裹我们自己的h5活动
    myPageData.OriginalUrl = `http://${location.host}/activities/blfz/phoneIndex.html?from=h5&openid=${myTemp.openid}&passport=${myTemp.passport}&flag=1&issubscribe=1&appid=${myTemp.appid}`;
  } else if (myPageData.PageId == 4465) {
    myPageData.OriginalUrl = `http://${location.host}/activities/yxt-submit/index.html?from=h5&openid=${myTemp.openid}&passport=${myTemp.passport}&flag=1&issubscribe=1&appid=${myTemp.appid}`;
  } else if (myPageData.PageId == 4467) {
    myPageData.OriginalUrl = `http://${location.host}/activities/yxt-submit/signup.html?from=h5&openid=${myTemp.openid}&passport=${myTemp.passport}&flag=1&issubscribe=1&appid=${myTemp.appid}`;
  } else if (myPageData.PageId == 4626) {
    myPageData.OriginalUrl = `http://${location.host}/activities/blfz/newIndex.html?from=h5&openid=${myTemp.openid}&passport=${myTemp.passport}&flag=1&issubscribe=1&appid=${myTemp.appid}`;
  } else if (myPageData.PageId == 5778) {
    myPageData.OriginalUrl = `http://${location.host}/activities/blfz/index12-11.html?from=h5&openid=${myTemp.openid}&passport=${myTemp.passport}&flag=1&issubscribe=1&appid=${myTemp.appid}`;
  } else if (
    (wj.subDomain == "qmyx" && myPageData.PageId == 169131) ||
    (wj.subDomain == "zhsd" && myPageData.PageId == 174447)
  ) {
    // 景尚中海上东区 测试 myPageData.PageId == 174447
    tmpStr = `ptype=tp1&pageid=${myPageData.PageId}&openid=${myTemp.openid}&passport=${myTemp.passport}&refereeopenid=${myTemp.refereeopenid}&projectid=${myPageData.Pid}&apihost=${cfg.apihost}&host=${location.host}`;
    if (myTemp.psn) {
      tmpStr += "&psn=" + myTemp.psn;
    }
    if (myTemp.rscuid) {
      tmpStr += "&rscuid=" + myTemp.rscuid;
    }
    if (myTemp.share_api) {
      tmpStr += "&share_api=" + encodeURIComponent(myTemp.share_api);
    }
    myPageData.OriginalUrl = wj.addUrlParamFromObj(myPageData.OriginalUrl, wj.urlParamToObj(tmpStr))
  } else if (wj.subDomain == "yuanquan" && myPageData && myPageData.OriginalUrl && myPageData.OriginalUrl.indexOf("/p/jings/flsk") > -1) {
    // 原圈云 富力首开 · 金禧璞瑅 myPageData.OriginalUrl.indexOf("/p/jings/") > -1
    tmpStr = `ptype=tp1&pageid=${myPageData.PageId}&openid=${myTemp.openid}&passport=${myTemp.passport}&refereeopenid=${myTemp.refereeopenid}&projectid=${myPageData.Pid}&apihost=${cfg.apihost}&host=${location.host}`;
    if (myTemp.psn) {
      tmpStr += "&psn=" + myTemp.psn;
    }
    if (myTemp.rscuid) {
      tmpStr += "&rscuid=" + myTemp.rscuid;
    }
    if (myTemp.share_api) {
      tmpStr += "&share_api=" + encodeURIComponent(myTemp.share_api);
    }
    myPageData.OriginalUrl = wj.addUrlParamFromObj(myPageData.OriginalUrl, wj.urlParamToObj(tmpStr))

  } else if ((myPageData.OriginalUrl && myPageData.OriginalUrl.indexOf("/web/zhonghai-sdqM/") > -1) || myPageData.PageId == 181429 || myPageData.PageId == 317510 || myPageData.PageId == 304361 || myPageData.PageId == 183947 || myPageData.PageId == 181718 || myPageData.PageId == 183944 || (wj.subDomain == 'qmyx' && myPageData.PageId == 169797)) {
    // 景尚中海上东区 myPageData.OriginalUrl.indexOf("/web/zhonghai-sdqM/") > -1
    // 景尚 东华滨湖壹号院 myPageData.PageId == 181429
    // 景尚 贵阳万达广场myPageData.PageId == 304361
    // 景尚 象屿招商蟠龙府 317510
    tmpStr = `ptype=tp1&pageid=${myPageData.PageId}&openid=${myTemp.openid}&passport=${myTemp.passport}&refereeopenid=${myTemp.refereeopenid}&projectid=${myPageData.Pid}&apihost=${cfg.apihost}&host=${cfg.isLoc ? 'zhsd.gbtse.com' : location.host}`;
    if (myTemp.psn) {
      tmpStr += "&psn=" + myTemp.psn;
    }
    if (myTemp.rscuid) {
      tmpStr += "&rscuid=" + myTemp.rscuid;
    }
    if (myTemp.share_api) {
      tmpStr += "&share_api=" + encodeURIComponent(myTemp.share_api);
    }
    if (myTemp.vrfid) {
      tmpStr += "&vrfid=" + encodeURIComponent(myTemp.vrfid);
    }

    if (location.hostname == 'localhost' && myPageData.PageId == 317510) {
      myPageData.OriginalUrl = myPageData.OriginalUrl.replace(wj.getHostFromUrl(myPageData.OriginalUrl) + '/h5/', 'localhost:2000/work/yuanquan/js-h5/')
    }
    myPageData.OriginalUrl = wj.addUrlParamFromObj(myPageData.OriginalUrl, wj.urlParamToObj(tmpStr))

    console.log(myPageData.OriginalUrl);
    if (myTemp.rscuid) {
      // 获取销售微信号
      $.ajax({
        type: "GET",
        url: api.wx,
        async: false,
        data: {
          j: JSON.stringify({
            "action": "/hb/HbUserAction/fansInfo",
            "requestParam": {
              obj: {
                openid: myTemp.rscuid
              }
            },
            "openid": myTemp.openid,
            "passport": myTemp.passport,
            "url": location.href
          })
        },
        success: function (data) {
          console.log(data.obj.wxqr);
          if (data.obj.wxqr) {
            $('.qr-code').attr('src', data.obj.wxqr)
            $('.saler-box').removeClass('hide')
          } else {
            $('.saler-box').addClass('hide')
            $('.no-qr').removeClass('hide')
          }
        }
      });

      wj.getUserInfo(function (data) {
        console.log(data.obj.user);
        let salerInfo = data.obj.user;
        myTemp.cardInfo = data.obj;
        // 销售信息
        $(".saler").removeClass("hide");
        $(".page").addClass("mt50");
        $(".saler-icon").attr("src", salerInfo.headimgurl)
        $(".saler-name").text(`${salerInfo.name}`)
        $(".saler-tel").text(`${salerInfo.mobile}`)
        $(".wechat").click(function () {
          $('.saler-dialog').removeClass('hide')
        })
        $(".saler-dialog").click(function () {
          $('.saler-dialog').addClass('hide')
        })
        $(".tel").click(function () {
          window.location.href = `tel:${salerInfo.mobile}`
        })
        $(".sms").click(function () {
          window.location.href = `sms:${salerInfo.mobile}`
        })
        // $(".info").click(function() {
        //   alert('info')
        // })
      }, myTemp.rscuid)
    }
  } else {
    let tmpObj1409 = {
      openid: myTemp.openid,
      passport: myTemp.passport
    }
    if (myTemp.refereeopenid) {
      tmpObj1409.refereeopenid = myTemp.refereeopenid;
    }
    if (myTemp.rscuid) {
      tmpObj1409.rscuid = myTemp.rscuid;
    }
    myPageData.OriginalUrl = wj.addUrlParamFromObj(myPageData.OriginalUrl, tmpObj1409)
  }

  if (myPageData.Isredirect_oriurl && myPageData.Isredirect_oriurl == 1) {
    // 微创需要跳转的,不要再加载到myFrame了
  } else {
    if (location.href.indexOf("noguide=1") > -1) {
      myPageData.OriginalUrl = wj.addUrlParamFromObj(myPageData.OriginalUrl, {
        noguide: 1
      })
    }
    // 测试iframeSdk
    if (cfg.isLoc && myPageData.PageId == 170244) {
      myPageData.OriginalUrl = 'http://localhost:2000/travel/gong/yuanquan/rsh5jssdk/dist/test-yqrsiframesdk.html';
    }
    if (cfg.isTest && myPageData.PageId == 170244) {
      myPageData.OriginalUrl = 'http://qmyx.putzip.com/h5/rsh5jssdk/test-yqrsiframesdk.html?t=' + new Date().getTime();
    }
    // 如果有内嵌链接的参数那么也带进去

    if (myTemp.extpar) {
      myPageData.OriginalUrl = wj.addUrlParamFromObj(myPageData.OriginalUrl, JSON.parse(decodeURIComponent(myTemp.extpar)))
    }
    if (cfg.isLoc) {
      myPageData.OriginalUrl = myPageData.OriginalUrl.replace("https", "http");
    }
    if (myPageData.PageId == 191986) {
      wj.getUserInfo(function (data) {
        console.log(111, 'getUserInfo', data)
        if (data && data.obj && data.obj.user && data.obj.user.nickname) {
          myPageData.OriginalUrl = wj.addUrlParamFromObj(myPageData.OriginalUrl, {
            nickname: encodeURIComponent(data.obj.user.nickname)
          })
          $("#myFrame").attr("src", myPageData.OriginalUrl);
          $(".index_scrim").css("display", "none");
        }
      }, myTemp.openid)
    } else {
      // 如果是原圈大转盘需要带上一些参数
      if (myPageData.Wmenu == "yq_lucky_wheel") {
        console.log(111, 'myTemp', myTemp);
        let tmpObj1363 = {
          pageid: myPageData.PageId,
          psn: myTemp.psn
        };
        if (myTemp.refereeopenid) {
          tmpObj1363.refereeopenid = myTemp.refereeopenid;
        }
        if (myTemp.rscuid) {
          tmpObj1363.rscuid = myTemp.rscuid;
        }
        let tmpUrlParam = wj.getParamFromUrl(location.href);
        if (tmpUrlParam.channel) {
          tmpObj1363.channel = tmpUrlParam.channel;
        }
        myPageData.OriginalUrl = wj.addUrlParamFromObj(myPageData.OriginalUrl, tmpObj1363)
      }
      if (location.href.startsWith("https:") && myPageData.OriginalUrl.startsWith("http:")) {
        myPageData.OriginalUrl = myPageData.OriginalUrl.replace("http:", "https:");
      }
      // 金地品牌2021购房者宜居调查
      // 问卷接收的额外参数  
      // questionnaireid: null,
      // show: null, //不同风格的展示页面编号
      // answerrate: null, //答题率（大于等于答题率才能提交）
      // appid: null, //如是h5所属的公众号appid
      // openid: null, //如是的h5授权的用户的openid
      // pageid: null, //h5的Id
      // refereeopenid: null, //h5分享人的openid
      // nickname: null, //如是的h5授权的用户的昵称
      // headimage: null, //如是的h5授权的用户的头像
      // share_link: null, //问卷页面分享的链接
      if (myPageData.PageId == 290778 || (wj.subDomain == 'dljdpp' && myTemp.isQuestionnaire) || (wj.subDomain == 'jdrcff' && myPageData.PageId == 298229)) {
        wj.getFansInfo(function (res) {
          console.log(999, res)
          if (res.obj) {
            let alreadyHaveUrlParam = wj.getParamFromUrl(myPageData.OriginalUrl);
            let addObj = {
              custom: 'dljdpp_2021_livability',
              appid: myTemp.appid,
              pageid: myPageData.PageId,
              host: location.host,
            };
            if (!alreadyHaveUrlParam.openid) {
              addObj.openid = myTemp.openid;
            }
            if (myTemp.refereeopenid) {
              addObj.refereeopenid = myTemp.refereeopenid
            }
            if (myTemp.rscuid) {
              addObj.rscuid = myTemp.rscuid
            }
            if (res.obj.nickname) {
              addObj.nickname = encodeURIComponent(res.obj.nickname);
            }
            if (res.obj.headimgurl) {
              addObj.headimage = encodeURIComponent(res.obj.headimgurl);
            }
            if (myTemp.purephonenumber) {
              addObj.mobile = myTemp.purephonenumber;
            }
            myPageData.OriginalUrl = wj.addUrlParamFromObj(myPageData.OriginalUrl, addObj)
            if (myPageData.OriginalUrl.startsWith("https:")) {
              myPageData.OriginalUrl = myPageData.OriginalUrl.replace("https:", location.protocol)
            } else {
              myPageData.OriginalUrl = myPageData.OriginalUrl.replace("http:", location.protocol)
            }
            $("#myFrame").attr("src", myPageData.OriginalUrl);
            $(".index_scrim").css("display", "none");
          }
        }, myTemp.openid);

      } else {
        if (myPageData.OriginalUrl.indexOf('wicre.rushizhineng.com%2Freserve') > -1) {
          location.href = myPageData.OriginalUrl;
        } else {
          // 如是大转盘直接跳出
          if (myPageData.OriginalUrl.indexOf("marketies/rsrc/rs/draw") > -1) {
            location.href = myPageData.OriginalUrl;
          } else {
            $("#myFrame").attr("src", myPageData.OriginalUrl);
            $(".index_scrim").css("display", "none");
          }
        }
      }
    }
  }

  var iframe = document.getElementById("myFrame");
  if (iframe.attachEvent) {
    iframe.attachEvent("onload", function () {
      if (myTemp.bottomBtnCount != 0) {
        $(".bottom").removeClass("hide");
      }
    });
  } else {
    iframe.onload = function () {
      if (myTemp.bottomBtnCount != 0) {
        $(".bottom").removeClass("hide");
      }
    };
  }
}
if (myPageData.Imgs) {
  myPageData.Imgs.forEach(function (e, i) {
    myTemp.arrSrc.push(e.filepath);
  })
}

if (myPageData.CsPic)
  myTemp.arrSrc.push(myPageData.CsPic);
if (myPageData.WxQrcode)
  myTemp.arrSrc.push(myPageData.WxQrcode);
myTemp.arrSrc.forEach(function (e, i) {
  if (e.indexOf(location.host) > -1 || e.indexOf("../") > -1) {
    myTemp.arrSrcMyServer.push(e);
  }
})
if (myTemp.arrSrcMyServer.length > 0 && false) {
  wj.loadImgs(myTemp.arrSrcMyServer, function () {
    console.count("加载图片");
  }, function () {
    $(".index_scrim").css("display", "none");
    bindMusic();
  })
} else {
  // $(".index_scrim").css("display", "none");
  bindMusic();
}

function bindMusic() {
  //绑定音乐
  if (myPageData.Music) {
    if (myPageData.Music.indexOf(".mp3") > -1 || myPageData.Music.indexOf(".MP3") > -1) {
      myTemp.audio = document.getElementById("music_audio");
      if (wj.browser.versions.ios) {
        myTemp.audio.src = myPageData.Music;
        myTemp.audio.load();
        document.addEventListener("WeixinJSBridgeReady", function () {
          myTemp.audio.play();
        }, false);
        $(".music_img").addClass("music_img_play");
      } else {
        // wj.loadAudio(myPageData.Music, function () {
        //     myTemp.audio.src = myPageData.Music;
        //     myTemp.audio.play();
        //     $(".music_img").addClass("music_img_play");
        // });
        // myTemp.audio.src = myPageData.Music;

        myTemp.audio.src = myPageData.Music;
        var isPlaying = myTemp.audio.currentTime > 0 && !myTemp.audio.paused && !myTemp.audio.ended && myTemp.audio.readyState > 2;
        if (!isPlaying) {
          setTimeout(function () {
            myTemp.audio.play().catch(function (e) {
              console.log("", e.message);
              console.log("", e.description);
            });
            $(".music_img").addClass("music_img_play");
          }, 150);
        } else {

        }
      }
      //点击音乐图标
      $(".music").on("click", function () {
        if (myTemp.audio.paused) {
          myTemp.audio.play();
          $(".music_img").addClass("music_img_play");
        } else {
          myTemp.audio.pause();
          $(".music_img").removeClass("music_img_play");
        }
      });
    } else {
      alert("仅支持mp3格式音乐！")
    }
  }
}

/**
 * layout
 */
function fixPagesHeight() {
  var windowHeight = $(window).innerHeight();
  var windowWidth = $(window).innerWidth();
  $(".cover").css({
    height: windowHeight,
    width: windowWidth
  });
  // 景尚中海上东区
  if (((myPageData.OriginalUrl && myPageData.OriginalUrl.indexOf("/web/zhonghai-sdqM/") > -1) || myPageData.PageId == 181429 || myPageData.PageId == 317510 || myPageData.PageId == 304361 || myPageData.PageId == 183947 || myPageData.PageId == 181718 || myPageData.PageId == 183944 || (wj.subDomain == 'qmyx' && myPageData.PageId == 169797)) && myTemp.rscuid) {
    $(".page").css({
      height: windowHeight - $(".saler").height(),
      width: windowWidth
    });
  } else {
    $(".page").css({
      height: windowHeight,
      width: windowWidth
    });
  }
  $("#myFrame").css({
    width: windowWidth
  });
  $(".page").css({
    "overflow-y": "hidden"
  })
  if (wj.qs("id") == 3730) {
    $("#myFrame").attr({
      "scrolling": "no"
    })
  }
  if (myPageData.OriginalUrl && (myPageData.OriginalUrl.indexOf("wx.whyimingkeji.com") > -1 || wj.subDomain == 'zhsd')) {
    $("#myFrame").attr({
      "scrolling": "no"
    })
  }
  if ((myPageData.Showpv && myPageData.Showpv == 1) || (myPageData.Showshares && myPageData.Showshares == 1) || (myPageData.Showsubcribepage && myPageData.Showsubcribepage == 1 && myPageData.Subcribepageurl)) {
    $(".page .music").css({
      top: "3.5rem"
    })
    $("#myFrame").css({
      height: windowHeight - $(".count").height()
    });
    if ((myPageData.Showpv && myPageData.Showpv == 1 || myPageData.Showshares && myPageData.Showshares == 1)) {
      getCount();
    }
    if (myPageData.Showsubcribepage && myPageData.Showsubcribepage == 1 && myPageData.Subcribepageurl != "") {
      $(".count_subcribe").removeClass("hide")
      $(".count_subcribe").on("click", function () {
        AddCount(14);
        location.href = myPageData.Subcribepageurl;
      })
    }

    //请求接口获取数量

    $(".count").removeClass("hide");
  }
}

fixPagesHeight();
window.onresize = function () {
  fixPagesHeight();
}
//根据配置显示按钮
if (myTemp.appid == "wx3d1ccb01e00a82b9") {
  $(".btn_dy_a .txt").html("报名");
}
if (myTemp.appid == "wxf1efeb9b9d6f6f06") {
  $(".btn_live_a .txt").html("活动");
}
if (myPageData.PageId == 3675 || myPageData.PageId == 3679) {
  $(".btn_dy_a .txt").html("报名");
  $(".btn_dy .item_warp").css({
    "transform": "scale(1.5)",
    "marginTop": "-4rem"
  })
}
if (myPageData.PageId == 4240 || myPageData.PageId == 4344 || myPageData.PageId == 4345 || myPageData.PageId == 4346 || myPageData.PageId == 4347) {
  $(".page .bottom").css({
    bottom: "2rem"
  });
  $(".btn_dy .item_warp").addClass("hide");
  $(".yxtyxh").attr("src", "http://assets.rurushishi.com/h5/img/yxtyxh-diaoyan.png");
}
if (myPageData.OriginalUrl && (myPageData.OriginalUrl.indexOf("recruit/detail") > -1 || myPageData.OriginalUrl.indexOf("marketies%2Frecruit") > -1)) {
  $(".btn_dy_a .txt").html("投递");
}
if (myPageData.PageId == 155545 || myPageData.PageId == 155681 || myPageData.PageId == 155680) {
  $(".btn_dy_a .txt").html("申请");
}

if (myPageData.Music && ![304657].includes(parseInt(myPageData.PageId))) {
  $(".music").css({ "display": "block" });
} else {
  $(".music").css({ "display": "none" });
}
if (myPageData.IsPhone) {
  $(".btn_th").css("display", "block");
  myTemp.bottomBtnCount++;
}
if (myPageData.Tel || myPageData.Propcall) {
  $(".btn_zd").css("display", "block");
  myTemp.bottomBtnCount++;
}
if (myPageData.Chat) {
  if (wj.browser.versions.wx) {
    $(".btn_zx").css("display", "block");
    myTemp.bottomBtnCount++;
  }
}
if (myPageData.NavUrl) {
  $(".btn_dh").css("display", "block");
  myTemp.bottomBtnCount++;
}
if (myPageData.WxCode && myPageData.WxQrcode) {
  $(".btn_gw").css("display", "block");
  myTemp.bottomBtnCount++;
}
if ((myPageData.Survey || myPageData.Surveyext) && myTemp.bottomBtnCount < 5) {
  if (location.href.indexOf("187.html") > -1) {
    //特定页面不显示调研
  } else {
    $(".btn_dy").css("display", "block");
    myTemp.bottomBtnCount++;
    new Promise(function (resolve, reject) {
      // getuserinfo
      $.ajax({
        type: "GET",
        async: true,
        url: api.wx,
        data: {
          j: JSON.stringify({
            "action": "/persid/PresidentAction/selectHbextend",
            "requestParam": {
              openid: myTemp.openid
            },
            "openid": myTemp.openid,
            "passport": myTemp.passport,
            "url": location.href
          })
        },
        success: function (data) {
          if (data && data.obj && data.obj.length > 0) {
            resolve(data.obj[0]);
          } else {
            resolve(false);
          }
        }
      });
    }).then(function (myUserInfo) {
      if (myPageData.Surveyext) {
        myPageData.Survey = myPageData.Surveyext;
      }
      if (myPageData.Survey.indexOf(".html?") > -1) {
        myPageData.Survey = myPageData.Survey + "&appid=" + myTemp.appid + "&openid=" + myTemp.openid + "&pageid=" + myPageData.PageId + "&host=" + location.host + "&refereeopenid=" + myTemp.refereeopenid;
      } else {
        myPageData.Survey = myPageData.Survey + "?appid=" + myTemp.appid + "&openid=" + myTemp.openid + "&pageid=" + myPageData.PageId + "&host=" + location.host + "&refereeopenid=" + myTemp.refereeopenid;
      }
      if (myUserInfo) {
        if (myUserInfo.name) {
          myPageData.Survey += "&nickname=" + encodeURIComponent(myUserInfo.name);
        }
        if (myUserInfo.headimgurl) {
          myPageData.Survey += "&headimage=" + encodeURIComponent(myUserInfo.headimgurl);
        }
      }
      if (myPageData.Surveyhideid && myPageData.Surveyhideanswer) {
        myPageData.Survey += "&Surveyhideid=" + myPageData.Surveyhideid + "&Surveyhideanswer=" + encodeURIComponent(myPageData.Surveyhideanswer);
      }
      var tmp781 = "";
      if (location.href.indexOf("&j=") > -1) {
        tmp781 = location.href.split("&j=")[0] + (myTemp.openid ? "&refereeopenid=" + myTemp.openid : "");
      } else {
        tmp781 = location.href + (myTemp.openid ? "&refereeopenid=" + myTemp.openid : "");
      }
      if (myTemp.psn) {
        tmp781 += "&psn=" + myTemp.psn;
      }
      myPageData.Survey += "&share_link=" + encodeURIComponent(tmp781);
      if (myPageData.Redirectto == 1 && myTemp.openid) {
        location.href = myPageData.Survey;
      }
    });
  }
}
if (myPageData.Mall && myTemp.bottomBtnCount < 5) {
  $(".btn_sc").css("display", "block");
  myTemp.bottomBtnCount++;
}
if (myPageData.LiveUrl && myTemp.bottomBtnCount < 5) {
  $(".btn_live").css("display", "block");
  myTemp.bottomBtnCount++;
}
if (myPageData.Record && myTemp.bottomBtnCount < 5) {
  $(".btn_record").css("display", "block");
  myTemp.bottomBtnCount++;
}
if (myPageData.Photo && parseInt(myPageData.Photo) == 1 && myTemp.bottomBtnCount < 5) {
  $(".btn_photo").css("display", "block");
  myTemp.bottomBtnCount++;
  comreq.getPhotoRewardConfig(myPageData.PageId).then((res) => {
    if (res.obj) {
      myTemp.photoRewardConfig = res.obj;
      console.log("myTemp.photoRewardConfig", myTemp.photoRewardConfig);
    }
  })
}

//街景
if (myPageData.Streeturl && myTemp.bottomBtnCount < 5) {
  $(".btn_street").css("display", "block");
  myTemp.bottomBtnCount++;
  $(".btn_street").on("click", function () {
    AddCount(8);
    location.href = myPageData.Streeturl;
  })
}
//周边
if (myPageData.Nearbyurl && myTemp.bottomBtnCount < 5) {
  $(".btn_nearby").css("display", "block");
  myTemp.bottomBtnCount++;
  $(".btn_nearby").on("click", function () {
    AddCount(9);
    location.href = myPageData.Nearbyurl;
  })
}
//抽奖
if (myPageData.Luckdrawurl && myTemp.bottomBtnCount < 5) {
  let luckdrawBtnName = '';
  if (myPageData.Luckdrawurl.indexOf('http') != 0) {
    let encodeUrls = JSON.parse(myPageData.Luckdrawurl)
    console.log(111, 'encodeUrls', encodeUrls)
    if (encodeUrls.position == 2) {
      // 悬浮按钮模式
      $(".btn_luckdraw2").removeClass("hide");
      luckdrawBtnName = "btn_luckdraw2";
      if (encodeUrls.name) {
        if (encodeUrls.name.length > 4) {
          encodeUrls.name = encodeUrls.name.substring(0, 4);
        }
        $(".btn_luckdraw2Name").html(encodeUrls.name)
      } else {
        $(".btn_luckdraw2Name").html('抽奖')
      }
    } else {
      if (encodeUrls.name) {
        $(".btn_luckdraw .txt").html(encodeUrls.name)
      }
      myTemp.bottomBtnCount++;
      $(".btn_luckdraw").css("display", "block");
      luckdrawBtnName = "btn_luckdraw";
    }
  } else {
    myTemp.bottomBtnCount++;
    $(".btn_luckdraw").css("display", "block");
    luckdrawBtnName = "btn_luckdraw";
  }
  $("." + luckdrawBtnName).on("click", function () {

    AddCount(10);
    if (myPageData.Luckdrawurl.indexOf('http') == 0) {
      location.href = myPageData.Luckdrawurl;
    } else {
      let encodeUrls = JSON.parse(myPageData.Luckdrawurl)
      if (encodeUrls.exturl) {
        if (myTemp.refereeopenid) {
          encodeUrls.exturl = wj.addUrlParamFromObj(encodeUrls.exturl, {
            refereeopenid: myTemp.refereeopenid
          })
        }
        location.href = encodeUrls.exturl
      } else {
        if (myTemp.refereeopenid) {
          encodeUrls.url = wj.addUrlParamFromObj(encodeUrls.url, {
            refereeopenid: myTemp.refereeopenid
          })
        }
        location.href = encodeUrls.url
      }
    }
  })
}
//评论
if (myPageData.Reviewurl && myTemp.bottomBtnCount < 5) {
  $(".btn_review").css("display", "block");
  myTemp.bottomBtnCount++;
  $(".btn_review").on("click", function () {
    AddCount(11);
    location.href = myPageData.Reviewurl;
  })
}
//表单
if ((myPageData.Formurl || myPageData.Formexturl) && myTemp.bottomBtnCount < 5) {
  $(".btn_form").css("display", "block");
  myTemp.bottomBtnCount++;
  if (myPageData.Formname) {
    $(".btn_form .txt").html(myPageData.Formname)
  }
  $(".btn_form").on("click", function () {
    AddCount(12);
    if (myPageData.Formexturl) {
      location.href = myPageData.Formexturl;
    } else {
      location.href = myPageData.Formurl;
    }
  })
}
// 更多表单
if (myPageData.Funcscfg && myTemp.bottomBtnCount < 5) {
  myPageData.Funcscfg = JSON.parse(myPageData.Funcscfg);
  if (myPageData.Funcscfg && myPageData.Funcscfg.length > 0) {
    myPageData.Funcscfg.forEach((item, index) => {
      if (myTemp.bottomBtnCount < 5) {
        $(".btn_form_more" + index).css("display", "block");
        myTemp.bottomBtnCount++;
        if (item.label) {
          $(".btn_form_more" + index + " .txt").html(item.label);
        }
        $(".btn_form_more" + index).on("click", function () {
          AddCount(12);
          if (item.exturl) {
            location.href = item.exturl;
          } else {
            location.href = item.url;
          }
        })
      }
    })
  }
}
// 小程序按钮
if (myPageData.Funcscfg_wxxcx && myTemp.bottomBtnCount < 5) {
  myPageData.Funcscfg_wxxcx = JSON.parse(myPageData.Funcscfg_wxxcx);
  if (myPageData.Funcscfg_wxxcx && myPageData.Funcscfg_wxxcx.length > 0) {
    myPageData.Funcscfg_wxxcx.forEach((item, index) => {
      if (myTemp.bottomBtnCount < 6) {
        if (item.xcxid && item.xcxname && item.xcxpath) {
          myTemp.bottomBtnCount++;
          $(".btn_xcx_more" + index).css("display", "block");
          var mpPath = item.xcxpath;
          if (mpPath.substring(0, 1) != "/") {
            mpPath = "/" + mpPath;
          }
          mpPath = wj.addUrlParamFromObj(mpPath, {
            gzhOpenid: myTemp.openid,
            pageid: myPageData.PageId
          })

          let script = document.createElement("script");
          script.type = "text/wxtag-template";
          script.text = `<img src="${item.xcxicon || 'https://assets.rurushishi.com/yq-rs-h5/xcxicon2.png'}" style=" width: 20px;height: 20px;margin: 10px auto 0 auto;display: block;"/>
          <span style="color: #bda472;font-size: 9px;margin-top: 5px;">${item.xcxname}</span>`;

          let html = `<wx-open-launch-weapp class="btn_xcx_more${index}_mp_launch_wx" username="${item.xcxid}" path="${mpPath}">${script.outerHTML}</wx-open-launch-weapp>`;
          $(".btn_xcx_more" + index + "_mp_launch").html(html);

          $(".btn_xcx_more" + index + "_mp_launch_wx").on('launch', function (e) {
            window.AddCount(100001 + index, {
              funcname: item.xcxname
            })
          });
        }
      }
    })
  }
}

//传播咨询
/**
 * 1、有rscuid聊天对象是rscuid
 * 2、以上步骤没有，则通过获取上级销售找到聊天对象
 * 3、以上步骤没有，则通过获取默认接待找到聊天对象
 * 4、以上步骤没有，则使用默认的PC端咨询回复
 */
async function setSpreadChat(isAfterActIpGet) {
  return new Promise(async (resolve, reject) => {
    if (myTemp.consultingLink && !isAfterActIpGet) {
      resolve(myTemp.consultingLink)
    } else {
      let toId = '';
      if (myTemp.rscuid && myTemp.rscuid != myTemp.openid) {
        toId = myTemp.rscuid;
      } else {
        let upSaleOpenid = await window.comreq.getUserUpFans();
        if (upSaleOpenid && false) {
          toId = upSaleOpenid;
        } else {
          let defaultSaleOpenid = await window.comreq.getReceptionByProject();
          if (defaultSaleOpenid) {
            toId = defaultSaleOpenid;
          }
        }
      }
      if (toId == '' && myPageData?.Other?.receptionOpenid) {
        toId = myPageData.Other.receptionOpenid;
      }
      if (toId) {
        myTemp.consultingLink = `${location.protocol}//${location.host}/marketies/${wj.browser.versions.wxwork ? 'qwdesk' : 'desk'}/pages/fans/sale-fans-interaction?receiveropenid=${toId}&projectid=${myPageData.Pid}&pageid=${myPageData.PageId}&referenceopenid=${myTemp.refereeopenid || ''}`;
        // if (cfg.isLoc || cfg.isTest) {
        // } else {
        //   myTemp.consultingLink = `${location.protocol}//${location.host}/newcode/src/chat_room.html?openid=${myTemp.openid}&passport=${myTemp.passport}&referenceopenid=${myTemp.refereeopenid}&rscuid=${myTemp.rscuid}&receiveropenid=${toId}&nickname=&pageid=${myPageData.PageId}&projectid=${myPageData.Pid}`;
        // }
      } else {
        myTemp.consultingLink = `${location.protocol}//${location.host}/marketies/rc/cus-service.html?mobile=${myPageData.Tel}&referenceopenid=${myTemp.refereeopenid}&pageid=${myPageData.PageId}`;
      }
      if (isAfterActIpGet) {
        myTemp.isAlreadyAfterActIpGetConsultingLink = true;
        setContentSelf();
      }
      resolve(myTemp.consultingLink)
    }
  })
};

if (myPageData.Isconsult && parseInt(myPageData.Isconsult) == 1 && myTemp.bottomBtnCount < 5) {
  $(".btn_consult").css("display", "block");
  myTemp.bottomBtnCount++;
  $(".btn_consult").on("click", function () {
    // AddCount(13);
    setSpreadChat().then(url => {
      // 在线售楼中心
      if (myTemp.entry == "zxslzx" && myTemp.t9id && myTemp.t9psn) {
        url = wj.addUrlParamFromObj(wj.getUrlRemoveParams(url), {
          entry: 'zxslzx',
          t9id: myTemp.t9id,
          t9psn: myTemp.t9psn
        })
      }
      if (myTemp.qwQrCodeUrl) {
        url = wj.addUrlParamFromObj(url, {
          qwQrCodeUrl: encodeURIComponent(myTemp.qwQrCodeUrl)
        })
      }
      location.href = url;
    })
  })
}
//关注
if (myPageData.Showsubcribebtn && parseInt(myPageData.Showsubcribebtn) == 1 && myTemp.bottomBtnCount < 5) {
  $(".btn_subcribe").css("display", "block");
  $(".btn_subcribe").on("click", function () {
    AddCount(15);
    location.href = myPageData.Subcribepageurl;
  })
  myTemp.bottomBtnCount++;
}

if (myPageData.WxCode && myPageData.WxQrcode) {
  $(".contact").removeClass("hide");
}
if (myPageData.Tel) {
  $(".customservice").removeClass("hide");
}
if (myPageData.WxCode && myPageData.WxQrcode && myPageData.Tel) {
  $(".dividingline").removeClass("hide");
}
if (myTemp.bottomBtnCount == 0) {
  $(".page .bottom").addClass("hide");
}
/**
 * bind data
 */
//绑定swiper 图片
if (myPageData.Imgs) {
  myPageData.Imgs.forEach(function (e, i) {
    // $(".swiper-wrapper").append("<div class='swiper-slide'><img src=" + e.filepath + "></div>");
  });
}

// 20201225不在采用这个逻辑了
// //绑定致电电话
// if (wj.qs("ucallphone")) {
//   $(".btn_zd_a").attr("href", "tel:" + wj.qs("ucallphone"));
// }
// else if (myPageData.Propcall) {
//   //在上传在线信息之后会调用getRegistUserMobile();
// } else {
//   $(".btn_zd_a").attr("href", "tel:" + myPageData.Tel);
// }
function getRegistUserMobile() {
  // 20201225不在采用这个逻辑了
  return;
  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbH5Action/getUserUpFans",
        "requestParam": {
          "pageid": parseInt(myPageData.PageId),
          "refereeopenid": myTemp.refereeopenid
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      myTemp.isGetUpUserMobile = true;
      if (data && data.obj) {
        myTemp.receiveMsgOpenId = data.obj;
        $.ajax({
          type: "GET",
          url: api.wx,
          data: {
            j: JSON.stringify({
              "action": "/global/User/getRegistUserMobile",
              "requestParam": {
                "openid": myTemp.receiveMsgOpenId
              },
              "openid": myTemp.openid,
              "passport": myTemp.passport,
              "url": location.href
            })
          },
          success: function (data) {
            if (data && data.obj) {
              myTemp.upUserMobile = data.obj;
              if (wj.isMobileNumber(myTemp.upUserMobile)) {
                $(".btn_zd").css("display", "block");
                $(".btn_zd_a").attr("href", "tel:" + myTemp.upUserMobile);
              } else {
                if (myPageData.Tel) {
                  $(".btn_zd").css("display", "block");
                  $(".btn_zd_a").attr("href", "tel:" + myPageData.Tel);
                }
              }
            }
          }
        });
      } else {
        $(".btn_zd_a").attr("href", "tel:" + myPageData.Tel);
      }
    }
  });
}
//绑定官微客服电话
$(".call_href").attr("href", "tel:" + myPageData.Tel);
//绑定官微二维码
$(".qrcode_img").attr("src", myPageData.WxQrcode);
//绑定官微微信号
$(".qrcode_wxno").text(myPageData.WxCode);
//绑定官微客服图片
$(".customservice_img").attr("src", myPageData.CsPic ? myPageData.CsPic : "http://assets.rurushishi.com/h5/img/customservice.png");

//点击致电
$(".btn_zd").on("click", function () {
  if (myTemp.rscuid && !myTemp.saleCardUserFansInfo) {
    comreq.fansInfo(function (res) {
      if (res.obj) {
        myTemp.saleCardUserFansInfo = res.obj;
      }
      let phone = (myTemp.saleCardUserFansInfo && (myTemp.saleCardUserFansInfo.ui_mobile || myTemp.saleCardUserFansInfo.mobile)) || myPageData.Tel || '';
      if (phone) {
        location.href = `tel:${phone}`;
      } else {
        alert('未配置默认电话')
      }
    }, myTemp.rscuid)
  } else {
    let phone = (myTemp.saleCardUserFansInfo && (myTemp.saleCardUserFansInfo.ui_mobile || myTemp.saleCardUserFansInfo.mobile)) || myPageData.Tel || '';
    if (phone) {
      location.href = `tel:${phone}`;
    } else {
      alert('未配置默认电话')
    }
  }
  AddCount(1);
})
//点击客服咨询
$(".btn_zx").on("click", function () {
  // AddCount(2);
  if (myPageData.Chat.indexOf("?") > -1) {
    myPageData.Chat += "&";
  } else {
    myPageData.Chat += "?";
  }
  myPageData.Chat += "mobile=" + myPageData.Tel + "&referenceopenid=" + myTemp.refereeopenid + "&pageid=" + myPageData.PageId;
  location.href = myPageData.Chat;
})
//点击调研
$(".btn_dy").on("click", function () {
  AddCount(3);
  //http://ddipctest.rushinews.com/web/ui/direction.html?page=rs1&classId=22464177237760&questionnaireId=22464176998656&tacheItemId=22464177249025
  // "appid": "asdf",//如是
  //     "openid": "asdf",//如是
  //     "pageid":1,//如是 页面id
  //     "correlationuserid": "sdf",//ddi userid
  //     "correlationextendid": "asfasdf",//ddi 问卷 tacheItemId
  //     "platformtype": 1,

  if (myPageData.PageId == 4240 || myPageData.PageId == 4344 || myPageData.PageId == 4345 || myPageData.PageId == 4346 || myPageData.PageId == 4347) {
    location.href = "http://yxtyxh.rushinews.com/activities/yxt-submit/signup.html?pageid=" + myPageData.PageId + "&refereeopenid=" + myTemp.refereeopenid;
  } else {
    if (myTemp.processinstanceid) {
      myPageData.Survey += `&processinstanceid=${myTemp.processinstanceid}`;
    }
    location.href = myPageData.Survey;
  }
})
//点击商城
$(".btn_sc").on("click", function () {
  AddCount(4);
  location.href = myPageData.Mall;
})
//点击直播
$(".btn_live").on("click", function () {
  AddCount(7);
  location.href = myPageData.LiveUrl;
})
//点击特惠
$(".btn_th").on("click", function () {
  $(".cover").removeClass("hide");
  $(".fav").css({
    height: "17rem"
  });
})
//点击特惠-数字按钮
$(".mytd").each(function (i, e) {
  if (i < 9) {
    $(e).on("click", function () {
      enterNum(i);
    })
  }
});
$(".td11").on("click", function () {
  enterNum(-1);
})

function enterNum(i) {
  var str = $(".input").text();
  if (!wj.isNumber(str)) {
    str = "";
  }
  $(".input").text(str + "" + (i + 1) + "");
}

$(".td12").on("click", function () {
  var str = $(".input").text();
  if (str == "") {
    str = "输入您的电话获得专属服务";
  }
  else if (wj.isNumber(str) && str.length > 1) {
    str = str.substring(0, str.length - 1);
  } else if (str.length == 1) {
    str = "输入您的电话获得专属服务";
  }
  $(".input").text(str);
})
$(".td12").on("taphold", function () {
  $(".input").text("输入您的电话获得专属服务");
})
//点击特惠-提交
$(".btn_submit").on("click", function () {
  var strPhone = $(".input").text();
  if (strPhone == "" || strPhone == "输入您的电话获得专属服务") {
    alert("请先填写手机号或电话号！");
  } else if (!wj.isMobileNumber(strPhone)) {
    alert("请填写正确格式的手机号或电话号！");
  } else {
    $(".fav").css({
      height: "0rem"
    });
    var data = {
      phone: strPhone,
      pageid: myPageData.PageId,
      channelid: wj.qs("ch", true),
      refereeopenid: myTemp.refereeopenid,
      openid: myTemp.openid
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
    yqAnalytics.setUserInfo({
      openId: myTemp.openid,
      phoneNumber: strPhone
    })
    biz.handlerYqAnalyticsEvent('entryPhoneNumber', {
      phoneNumber: strPhone
    })
    $.ajax({
      type: "POST",
      url: api.h5 + "act=entry",
      data: data,
      success: function () {
        alert("留电成功！");
      }
    });
  }
});
function actEntry(strPhone, from, callback) {
  var data = {
    phone: strPhone,
    pageid: myPageData.PageId,
    channelid: wj.qs("ch", true),
    refereeopenid: myTemp.refereeopenid,
    openid: myTemp.openid
  }
  if (myTemp.rscuid) {
    data.rscuid = myTemp.rscuid;
  }
  if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
  $.ajax({
    type: "POST",
    url: api.h5 + "act=entry",
    data: data,
    success: function () {
      if (from == 'sdk') {
        if (callback) callback(1);
      } else {
        alert("留电成功！");
      }
      yqAnalytics.setUserInfo({
        openId: myTemp.openid,
        phoneNumber: strPhone
      })
      biz.handlerYqAnalyticsEvent('entryPhoneNumber', {
        phoneNumber: strPhone,
        type: 1
      })
    },
    error: function (jqXHR, textStatus, errorThrown) {
      // /*弹出jqXHR对象的信息*/
      // alert(jqXHR.responseText);
      // alert(jqXHR.status);
      // alert(jqXHR.readyState);
      // alert(jqXHR.statusText);
      // /*弹出其他两个参数的信息*/
      // alert(textStatus);
      // alert(errorThrown);
      if (from == 'sdk') {
        if (callback) callback(errorThrown);
      }
    }
  });
}
//点击导航
$(".btn_dh").on("click", function () {
  AddCount(5);
  location.href = myPageData.NavUrl;
})
//点击 官微
$(".btn_gw").on("click", function () {
  $(".cover").removeClass("hide");
  if (cfg.isLoc) {
    if (cfg.helpShowWx % 2 == 0) {
      $(".wx_number").addClass("hide");
      $(".wx_qrcode").removeClass("hide");
    } else {
      $(".wx_qrcode").addClass("hide");
      $(".wx_number").removeClass("hide");
    }
  } else {
    if (wj.browser.versions.wx) {
      $(".wx_number").addClass("hide");
      $(".wx_qrcode").removeClass("hide");
    } else {
      $(".wx_qrcode").addClass("hide");
      $(".wx_number").removeClass("hide");
    }
  }
  $(".wx").css({
    height: "15rem"
  });
  cfg.helpShowWx++;
})
//点击 留言
$(".btn_record").on("click", function () {
  $(".cover").removeClass("hide");
  $(".record").css({
    height: "14rem"
  });
  $(".msg_content").html(myPageData.Record);
});
//点击 晒照
$(".btn_photo").on("click", function () {
  AddCount(6);
  $(".cover").removeClass("hide");
  $(".photo").css({
    height: "20rem"
  });
  document.getElementsByTagName("body")[0].style.overflow = "hidden";
  document.getElementsByTagName("body")[0].style.maxHeight = "100vh";
  $(".msg_content").html(myPageData.Record);
});
//点击 留言弹出框-留言
myTemp.record_localId = 0;
myTemp.record_timer = null;
myTemp.record_timer_num = 1;
$(".record_btn_img").on("click", function () {
  if (myTemp.isRecordIng == 0) {
    myTemp.isRecordIng = 1
    myTemp.record_timer_num = 1;
    myTemp.record_timer = setInterval(function () {
      if (myTemp.record_timer_num % 2 == 0) {
        $(".record_btn_img").attr("src", "http://assets.rurushishi.com/h5/img/record_btn.png");

      } else {
        $(".record_btn_img").attr("src", "http://assets.rurushishi.com/h5/img/record_btn_ing.png");
      }
      myTemp.record_timer_num++;
    }, 500)
    wx.startRecord();
  } else if (myTemp.isRecordIng == 1) {
    myTemp.isRecordIng = 0;
    $(".record_btn_img").attr("src", "http://assets.rurushishi.com/h5/img/record_btn.png");
    clearInterval(myTemp.record_timer);
    $(".msg").removeClass("hide");
    wx.stopRecord({
      success: function (res) {
        var localId = res.localId;

      }
    });
  }
});
//点击 晒照弹出框 上传
document.getElementById("fileToUpload").addEventListener("change", function (event) {
  if (typeof FileReader == "undefined") {
    alert("您的浏览器不支持图像上传！");
  }
  $(".face-cut_ok").text("确 认");
  UploadImg(this.files[0]);
  event.target.value = '';
});

function UploadImg(file) {
  if (!file) {
    return;
  }
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onloadend = function (e) {
    myTemp.sendImgBaseData = this.result;
    if (myTemp.imgFaceCut == null) {
      myTemp.imgFaceCut = $('.face-cut_container >img');
      myTemp.imgFaceCut.attr("src", myTemp.sendImgBaseData);
      myTemp.imgFaceCut.cropper({
        aspectRatio: 9 / 9,
        crop: function (data) {

        }
      });
    } else {
      myTemp.imgFaceCut.cropper('replace', myTemp.sendImgBaseData);
    }
    $(".face-cut").removeClass("hide");
    closeCard();
    // function cut() {
    //     var $imgData = $img.cropper('getCroppedCanvas')
    //     var dataurl = $imgData.toDataURL('image/png');
    //     console.log(dataurl)
    // }


  }
}

$(".face-cut_ok").on("click", function () {
  if ($(".face-cut_ok").text() == "上传中...") {
    return;
  }
  var tmpImgData = myTemp.imgFaceCut.cropper('getCroppedCanvas')
  myTemp.sendImgBaseData = tmpImgData.toDataURL('image/png');
  $(".face-cut_ok").text("上传中...");
  canvasDataURL(myTemp.sendImgBaseData, {
    maxSize: 600,
    quality: 1
  }, function (myData) {
    myTemp.sendImgBaseData = myData;
    console.log(myTemp.sendImgBaseData)
    $.ajax({
      type: "post",
      url: api.wx,
      data: {
        j: JSON.stringify({
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "action": "/ai/face/FaceAction/upload",
          "requestParam": {
            "obj": {
              "device": "wx",
              "base64img": myTemp.sendImgBaseData.split(',')[1],
              "projectid": myPageData.Pid,
              pageid: parseInt(myPageData.PageId)
            }
          }
        })
      },
      success: function (data) {
        if (data && data.code == 0 && data.obj) {
          if (data.errmsg == "上传成功") {
            $(".msg_content").html(myTemp.photoRewardConfig.uploadoktext || data.errmsg)
          } else {
            $(".msg_content").html(data.errmsg)
          }
          $(".msg").removeClass("hide");
          $(".msg_title").on("click", function () {
            $(".face-cut").addClass("hide");
          })
        } else {
          $(".msg_content").html(data.errmsg || '上传失败！')
          $(".msg").removeClass("hide");
          $(".msg_title").on("click", function () {
            $(".face-cut").addClass("hide");
          })
        }
      }
    });
  })
})


$(".face-cut_cancel").on("click", function () {
  $(".face-cut").addClass("hide");
})
$(".face-cut_rotate").on("click", function () {
  myTemp.imgFaceCut.cropper('rotate', 90);
})

function canvasDataURL(path, obj, callback) {
  var img = new Image();
  img.src = path;
  img.onload = function () {
    var that = this;
    // 默认按比例压缩
    var w = that.width,
      h = that.height,
      scale = w / h;
    if (w <= obj.maxSize) {
      return callback(path)
    }
    if (obj.maxSize) {
      if (w > h) {
        w = obj.maxSize;
        h = w / scale;
      } else {
        h = obj.maxSize;
        w = h * scale;
      }
    } else {
      w = obj.width || w;
      h = obj.height || (w / scale);
    }

    var quality = 0.7;  // 默认图片质量为0.7
    //生成canvas
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    // 创建属性节点
    canvas.width = w;
    canvas.height = h;
    ctx.drawImage(that, 0, 0, w, h);
    if (wj.browser.versions.ios) {
      // canvas.width = h;
      // canvas.height = w;
      // ctx.rotate(90 * Math.PI / 180);
      // ctx.drawImage(this, 0, 0, w, -h);
    }
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality;
    }
    // quality值越小，所绘制出的图像越模糊
    var base64 = canvas.toDataURL('image/jpeg', quality);
    // 回调函数返回base64的值

    callback(base64);
  }
}

//关闭弹出框
$(".msg_title").on("click", function () {
  $(".msg").addClass("hide");
});
//点击 页面图片
// $(".swiper-slide").on("click", function () {
//     closeCard();
// })
$(".image-text").on("click", function () {
  closeCard();
});
$(".cover").on("click", function () {
  closeCard();
})

function closeCard() {
  $(".cover").addClass("hide");
  $(".fav").css({
    height: "0rem"
  });
  $(".wx").css({
    height: "0rem"
  });
  $(".record").css({
    height: "0rem"
  });
  $(".photo").css({
    height: "0rem"
  });
  document.getElementsByTagName("body")[0].style.overflow = "";
  document.getElementsByTagName("body")[0].style.maxHeight = "";
}

//初始化Swiper
// var mySwiper = new Swiper('.swiper-container', {
//
//     direction: 'vertical',
//     lazyLoading: true,
//     mousewheelControl: true,
//     watchSlidesProgress: true,
//     onInit: function (swiper) {
//         swiper.myactive = 0;
//     },
//     onProgress: function (swiper) {
//         for (var i = 0; i < swiper.slides.length; i++) {
//             var slide = swiper.slides[i];
//             var progress = slide.progress;
//             var translate, boxShadow;
//
//             translate = progress * swiper.height * 0.8;
//             scale = 1 - Math.min(Math.abs(progress * 0.2), 1);
//             boxShadowOpacity = 0;
//
//             slide.style.boxShadow = '0px 0px 10px rgba(0,0,0,' + boxShadowOpacity + ')';
//
//             if (i == swiper.myactive) {
//                 es = slide.style;
//                 es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = 'translate3d(0,' + (translate) + 'px,0) scale(' + scale + ')';
//                 es.zIndex = 0;
//             } else {
//                 es = slide.style;
//                 es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = '';
//                 es.zIndex = 1;
//             }
//         }
//     },
//     onTransitionEnd: function (swiper, speed) {
//         for (var i = 0; i < swiper.slides.length; i++) {
//         }
//
//         swiper.myactive = swiper.activeIndex;
//
//     },
//     onSetTransition: function (swiper, speed) {
//
//         for (var i = 0; i < swiper.slides.length; i++) {
//
//             es = swiper.slides[i].style;
//             es.webkitTransitionDuration = es.MsTransitionDuration = es.msTransitionDuration = es.MozTransitionDuration = es.OTransitionDuration = es.transitionDuration = speed + 'ms';
//
//         }
//
//     },
//     onSlideChangeEnd: function (swiper) {
//         if (swiper.activeIndex == swiper.slides.length - 1) {
//             $(".arrow").addClass("hide");
//
//
//         } else {
//             $(".arrow").removeClass("hide");
//
//         }
//
//         if (swiper.activeIndex == 1) {
//
//         }
//
//         AddHit(myPageData.Imgs[swiper.activeIndex].id);
//     }
// });
//统计点击
// 打开小程序从100001（含）开始，另外增加了一个 funcname 字段（小程序的名称）
window.AddCount = function (type, addP) {
  if (myPageData.PageId) {
    var postData = {
      atype: type,
      pageid: myPageData.PageId,
      openid: myTemp.openid,
      refereeopenid: myTemp.refereeopenid
    };
    if (addP) {
      postData = {
        ...postData,
        ...addP
      }
    }
    if (myTemp.rscuid) {
      postData.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) postData.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=adv",
      data: postData
    });
  }
}

myTemp.guid = wj.getGuid();

//统计在线时长
function SendTime() {
  if (myPageData && myPageData.Ispackmode && parseInt(myPageData.Ispackmode) == 2) {
    // 多维构建 不在这里记录
    return
  }
  if (myPageData.PageId) {
    var data = {
      openid: myTemp.openid,
      pageid: myPageData.PageId,
      tempid: myTemp.guid,
      channelid: wj.qs("ch", true),
      refereeopenid: myTemp.refereeopenid,
      projectid: myPageData.Pid
    };
    if (myTemp.psn) {
      data.psn = myTemp.psn;
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=ip",
      data: data,
      complete: function () {
        if (!myTemp.rscuid || myTemp.rscuid == myTemp.openid) {
          if (!myTemp.isAlreadyAfterActIpGetConsultingLink) {
            setSpreadChat(true);
          }
          if (myPageData.Propcall && !myTemp.isGetUpUserMobile) {
            getRegistUserMobile();
          }
        }
      }
    });
  }
}

if ((wj.browser.versions.wx && myTemp.openid) || !wj.browser.versions.wx) {
  setTimeout(function () {
    SendTime();
    setInterval(SendTime, 3000);
  }, 1000)
}

//统计查看每张图片的次数
// AddHit(myPageData.Imgs[0].id);//记录第一张图片
function AddHit(imgId) {
  if (myPageData.PageId) {
    var data = {
      id: imgId,
      refereeopenid: myTemp.refereeopenid,
      openid: myTemp.openid,
    };
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=doc",
      data: data
    });
  }
}

var shareLink = "";
// 微创 好友助力和好友砍价处理
if (parseInt(myPageData.Ispackmode) == 2 &&
  (
    myTemp.oldOriginalUrl.indexOf("hyzl") > -1 ||
    myTemp.oldOriginalUrl.indexOf("hykj") > -1
  )
) {

  // var zhuliInterValCount=0;
  var zhuliInterVal = setInterval(function () {
    var zhuliData = {
      ActId: parseInt(tmpActId),
      wid: parseInt(tmpWid),
      OpenId: myTemp.openid,
    }
    console.log("zhuli参数:", zhuliData)
    $.ajax({
      type: "GET",
      async: false,
      // url: "http://wicre.rushinews.com/games/AddPlayForZuli",
      url: "http://wicre.rushinews.com/games/GetParticipateId",
      data: zhuliData,
      dataType: "jsonp",
      jsonpCallback: "run"
    });
    // zhuliInterValCount++;
    // if(zhuliInterValCount==5){
    //     clearInterval(zhuliInterVal);
    // }
  }, 1000);

  function run(data) {
    console.log("zhuli返回:", data)
    if (data && data.success && data.participateId && data.participateId > 0) {
      if (shareLink.indexOf("?") > -1) {
        shareLink += "&participateid=" + data.participateId;
      } else {
        shareLink += "?participateid=" + data.participateId;
      }
      // alert(shareLink);
      clearInterval(zhuliInterVal);
      initWXJSSDK();
    }
  }

}

// 微创 摇一摇
if (
  (parseInt(myPageData.Ispackmode) == 2 && myTemp.oldOriginalUrl.indexOf("yaoyiyao") > -1)
  || myPageData.PageId == "2239"
) {
  wj.cookie.set("yaoyiyao", 0, 60 * 10, ".rushinews.com");
  var drawCount = 0;
  //摇一摇抽奖
  function _draw() {
    drawCount++;
    wj.cookie.set("yaoyiyao", drawCount, 60, ".rushinews.com");
  }

  function _initShake() {
    var shake = 2000,
      last_update = 0,
      count = 0,
      x = 0, y = 0, z = 0, last_x = 0, last_y = 0, last_z = 0;
    if (window.DeviceMotionEvent) {
      window.addEventListener("devicemotion", function (eventData) {
        var acceleration = eventData.accelerationIncludingGravity,
          currTime = new Date().valueOf(),
          diffTime = currTime - last_update;
        if (diffTime > 100) {
          last_update = currTime;
          x = acceleration.x;
          y = acceleration.y;
          z = acceleration.z;
          var speed = Math.abs(x + y + z - last_x - last_y - last_z) / diffTime * 10000
          if (speed > shake) {
            count++;
            _draw();
          }
          last_x = x;
          last_y = y;
          last_z = z;
        }
      }, false);
    } else {
      // alert("本设备不支持摇一摇！");
    }
  }
  _initShake();
}

function initWXJSSDK(extTitle, extDesc, extImg, extLinkParams) {
  if (!myTemp.openid) {
    return;
  }
  if (!myPageData.WxShare) {
    return;
  }

  var shareTitle = extTitle || myPageData.WxShare.Title || myPageData.BrowserTabTitle;
  var shareDesc = extDesc || myPageData.WxShare.Description || myPageData.BrowserTabTitle;
  var shareImg = extImg || myPageData.WxShare.FilePath;

  var usercard2_masteropenid = wj.cookie.get("usercard2_masteropenid");
  if (usercard2_masteropenid) {
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "action": "/hb/HbUserAction/fansInfo",
          "requestParam": {
            obj: {
              openid: usercard2_masteropenid
            }
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        var cardinfo = data.obj;
        var myhost = location.host.indexOf("localhost") > -1 ? "qmyx.rushinews.com" : location.host;
        shareLink = `http://${myhost}/h5/usercard2.html?openid=${cardinfo.openid}&refereeopenid=${myTemp.openid}`;
        shareTitle = `我是${cardinfo.gappname || cardinfo.projectname}的${cardinfo.ui_name || cardinfo.name || cardinfo.nickname}，欢迎您随时联系`;
        shareDesc = `手机号：${cardinfo.ui_mobile || cardinfo.mobile}${cardinfo.ui_weixin ? "微信号：" + cardinfo.ui_weixin : ""}`;
        shareImg = cardinfo.headimgurl;
      }
    });
  }

  var tmpUrl2047 = api.wx;
  if (location.host.indexOf("fqjzw.") > -1 || location.host.indexOf("qdpdats.") > -1 || location.host.indexOf("yqjisu.") > -1 || location.host.indexOf("zyljxyf.") > -1
    || location.host.indexOf("jsby.") > -1
    || location.host.indexOf("xzsklf.") > -1) {
    tmpUrl2047 = location.protocol + "//shjinbao.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("jxwk.") > -1 || location.host.indexOf("zhzy.") > -1 || location.host.indexOf("zagbgn.") > -1) {
    tmpUrl2047 = location.protocol + "//yunmeiha.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("rdjt.") > -1 || location.host.indexOf("shhxbst.") > -1) {
    tmpUrl2047 = location.protocol + "//lsdyb.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("wlcbinh.") > -1 || location.host.indexOf("hllsq.") > -1 || location.host.indexOf("qcbdt.") > -1) {
    tmpUrl2047 = location.protocol + "//haopanyu.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("hdlyzsx.") > -1 || location.host.indexOf("lxfdcwxq.") > -1) {
    tmpUrl2047 = location.protocol + "//yuanquan.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("baolong.") > -1 || location.host.indexOf("hyhtd.") > -1) {
    tmpUrl2047 = location.protocol + "//loupany.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("hxdcj.") > -1) {
    tmpUrl2047 = location.protocol + "//yqkjw.ttrushi.com/qc-webapp/wxapi.do";
  }

  function isSalerFunc() {
    // 判断当前打开的人是不是销售
    wj.getUserInfo(function (data) {
      let userInfo = data.obj;
      myTemp.userInfo = data.obj;
      if (userInfo && userInfo.user && userInfo.user.cardno && userInfo.role && userInfo.role.length) {
        myTemp.isSale = true
      }
      getTmpUrl2047()
      showSalePanel();
    }, myTemp.openid)
  }
  isSalerFunc()
  function getTmpUrl2047() {
    $.ajax({
      type: "GET",
      url: tmpUrl2047,
      data: {
        j: JSON.stringify({
          openid: location.host.indexOf("fqjzw.") > -1 ? 'oPg9r1Smqfm7L0xRQg31bv3QEurM' : myTemp.openid,
          passport: location.host.indexOf("fqjzw.") > -1 ? 'b6ea31a39077f68fb85ba41109f51b40' : myTemp.passport,
          "vericode": "",
          "url": location.href,
          "action": "getAppid",
          "requestParam": {}
        }),
        t: 6
      },
      success: function (data) {
        if (data.code < 0) {
          return;
        }
        if (!usercard2_masteropenid) {
          if (!shareLink) {
            let paramsObj = wj.getParamFromUrl(location.href)
            console.log(myTemp.isSale);
            if (paramsObj.j) {
              delete paramsObj.j;
            }
            console.log(paramsObj);
            paramsObj.refereeopenid = myTemp.openid
            if (myTemp.isSale) {
              paramsObj.rscuid = myTemp.openid
            }
            let noParamsUrl = wj.getUrlRemoveParams(location.href)
            shareLink = wj.addUrlParamFromObj(noParamsUrl, paramsObj)
          }

          if (extLinkParams) {
            let shareLinkParam = wj.getParamFromUrl(shareLink);
            if (shareLinkParam && shareLinkParam.extpar) {
              delete shareLinkParam.extpar;
            }
            shareLink = wj.addUrlParamFromObj(wj.getUrlRemoveParams(shareLink), shareLinkParam);
            shareLink = wj.addUrlParamFromObj(shareLink, {
              extpar: encodeURIComponent(JSON.stringify(extLinkParams))
            })
          } else if (myTemp.extpar) {
            let shareLinkParam = wj.getParamFromUrl(shareLink);
            if (shareLinkParam && shareLinkParam.extpar) {
              delete shareLinkParam.extpar;
            }
            shareLink = wj.addUrlParamFromObj(wj.getUrlRemoveParams(shareLink), shareLinkParam);
            shareLink = wj.addUrlParamFromObj(shareLink, {
              extpar: myTemp.extpar
            })
          }
          if (myTemp.isSale) {
            let tmpUrlParam2740 = wj.getParamFromUrl(shareLink);
            tmpUrlParam2740.rscuid = myTemp.openid;
            shareLink = wj.addUrlParamFromObj(wj.getUrlRemoveParams(shareLink), tmpUrlParam2740);
          }
          shareLink = wj.addUrlParamFromObj(shareLink, {
            tt: new Date().getTime()
          })
          if (myTemp.share_api) {
            shareLink = myTemp.share_api.replace("{desturl}", encodeURIComponent(shareLink));
          }
        }
        myTemp.appid = data.obj;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.obj, // 必填，公众号的唯一标识
          timestamp: data.jsParams.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.jsParams.noncestr, // 必填，生成签名的随机串
          signature: data.jsParams.signature, // 必填，签名，见附录1
          jsApiList: [
            'hideMenuItems',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'getLocation',
            'openLocation',
            'previewImage'
          ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          openTagList: [
            'wx-open-launch-weapp',
            'wx-open-launch-app'
          ]
        });
        wx.ready(function () {
          if (myPageData.Forbidshare) {
            wx.hideMenuItems({
              menuList: [
                "menuItem:share:appMessage",
                "menuItem:share:timeline",
                "menuItem:share:qq",
                "menuItem:share:weiboApp",
                "menuItem:share:QZone",
                "menuItem:favorite",
                "menuItem:share:facebook",
                "menuItem:share:QZone",
                "menuItem:editTag",
                "menuItem:delete",
                "menuItem:copyUrl",
                "menuItem:originPage",
                "menuItem:readMode",
                "menuItem:openWithQQBrowser",
                "menuItem:openWithSafari",
                "menuItem:share:email",
                "menuItem:share:brand"
              ]
            });
          }
          if (window.frames && window.frames.length > 0) {
            window.frames[0].postMessage({
              action: 'wxready',
              data: null,
            }, "*")
          }
          window.ContentSelfAudio = new Audio();
          window.ContentSelfAudio.src =
            "https://assets.rurushishi.com/sharelib/iPhone.mp3";
          wx.onMenuShareTimeline({
            title: shareTitle,
            link: shareLink,
            imgUrl: shareImg,
            success: function () {
              wxShare();
            },
            cancel: function () {

            }
          });

          wx.onMenuShareAppMessage({
            title: shareTitle,
            desc: shareDesc,
            link: shareLink,
            imgUrl: shareImg,
            type: '',
            dataUrl: '',
            success: function () {
              wxShare();
            },
            cancel: function () {

            }
          });

          wx.onMenuShareQQ({
            title: shareTitle,
            desc: shareDesc,
            link: shareLink,
            imgUrl: shareImg,
            success: function () {
              wxShare();
            },
            cancel: function () {

            }
          });

          wx.onMenuShareWeibo({
            title: shareTitle,
            desc: shareDesc,
            link: shareLink,
            imgUrl: shareImg,
            success: function () {
              wxShare();
            },
            cancel: function () {

            }
          });

          wx.onMenuShareQZone({
            title: shareTitle,
            desc: shareDesc,
            link: shareLink,
            imgUrl: shareImg,
            success: function () {
              wxShare();
            },
            cancel: function () {

            }
          });

          if (myPageData.Opengps) {
            wx.getLocation({
              type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: function (res) {
                var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                var speed = res.speed; // 速度，以米/每秒计
                var accuracy = res.accuracy; // 位置精度
                // alert(`维度${latitude} 经度${longitude} 速度${speed} 精度${accuracy}`)
                uploadLocation(latitude, longitude, speed, accuracy);
                biz.handlerYqAnalyticsEvent('authLocation')
              }
            });
          }
        });
      }
    })
  }

  // $.ajax({
  //   type: "GET",
  //   url: tmpUrl2047,
  //   data: {
  //     j: JSON.stringify({
  //       openid: location.host.indexOf("fqjzw.") > -1 ? 'oPg9r1Smqfm7L0xRQg31bv3QEurM' : myTemp.openid,
  //       passport: location.host.indexOf("fqjzw.") > -1 ? 'b6ea31a39077f68fb85ba41109f51b40' : myTemp.passport,
  //       "vericode": "",
  //       "url": location.href,
  //       "action": "getAppid",
  //       "requestParam": {}
  //     }),
  //     t: 6
  //   },
  //   success: function (data) {
  //     if (data.code < 0) {
  //       return;
  //     }
  //     if (!usercard2_masteropenid) {
  //       if (!shareLink) {
  //         if (myTemp.isSale) {
  //           shareLink = `http://${location.host}/h5/tp1.html?id=${myPageData.PageId}&refereeopenid=${myTemp.openid}`;
  //         } else {
  //           shareLink = `http://${location.host}/h5/tp1.html?id=${myPageData.PageId}&refereeopenid=${myTemp.refereeopenid}`;
  //         }
  //       } else {

  //       }
  //       if (myTemp.psn) {
  //         shareLink += "&psn=" + myTemp.psn;
  //       }
  //       console.log(myTemp.share_api);
  //       if (myTemp.share_api) {
  //         shareLink = myTemp.share_api.replace("{desturl}", encodeURIComponent(shareLink));
  //       }
  //     }

  //     wx.config({
  //       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  //       appId: data.obj, // 必填，公众号的唯一标识
  //       timestamp: data.jsParams.timestamp, // 必填，生成签名的时间戳
  //       nonceStr: data.jsParams.noncestr, // 必填，生成签名的随机串
  //       signature: data.jsParams.signature, // 必填，签名，见附录1
  //       jsApiList: [
  //         'onMenuShareTimeline',
  //         'onMenuShareAppMessage',
  //         'onMenuShareQQ',
  //         'onMenuShareWeibo',
  //         'onMenuShareQZone',
  //         'getLocation',
  //         'openLocation'
  //       ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  //     });
  //     wx.ready(function () {
  //       if (window.frames && window.frames.length > 0) {
  //         window.frames[0].postMessage({
  //           action: 'wxready',
  //           data: null,
  //         }, "*")
  //       }
  //       window.ContentSelfAudio = new Audio();
  //       window.ContentSelfAudio.src =
  //         "https://assets.rurushishi.com/sharelib/iPhone.mp3";
  //       wx.onMenuShareTimeline({
  //         title: shareTitle,
  //         link: shareLink,
  //         imgUrl: shareImg,
  //         success: function () {

  //           wxShare();
  //         },
  //         cancel: function () {

  //         }
  //       });

  //       wx.onMenuShareAppMessage({
  //         title: shareTitle,
  //         desc: shareDesc,
  //         link: shareLink,
  //         imgUrl: shareImg,
  //         type: '',
  //         dataUrl: '',
  //         success: function () {

  //           wxShare();
  //         },
  //         cancel: function () {

  //         }
  //       });

  //       wx.onMenuShareQQ({
  //         title: shareTitle,
  //         desc: shareDesc,
  //         link: shareLink,
  //         imgUrl: shareImg,
  //         success: function () {

  //           wxShare();
  //         },
  //         cancel: function () {

  //         }
  //       });

  //       wx.onMenuShareWeibo({
  //         title: shareTitle,
  //         desc: shareDesc,
  //         link: shareLink,
  //         imgUrl: shareImg,
  //         success: function () {

  //           wxShare();
  //         },
  //         cancel: function () {

  //         }
  //       });

  //       wx.onMenuShareQZone({
  //         title: shareTitle,
  //         desc: shareDesc,
  //         link: shareLink,
  //         imgUrl: shareImg,
  //         success: function () {

  //           wxShare();
  //         },
  //         cancel: function () {

  //         }
  //       });

  //       if (myPageData.Opengps) {
  //         wx.getLocation({
  //           type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
  //           success: function (res) {
  //             var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
  //             var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
  //             var speed = res.speed; // 速度，以米/每秒计
  //             var accuracy = res.accuracy; // 位置精度
  //             // alert(`维度${latitude} 经度${longitude} 速度${speed} 精度${accuracy}`)
  //             uploadLocation(latitude, longitude, speed, accuracy);
  //           }
  //         });
  //       }

  //     });
  //   }
  // });
}

function uploadLocation(latitude, longitude, speed, accuracy) {
  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbPageReaderDistributionAction/add",
        "requestParam": {
          "openid": myTemp.openid,
          "latitude": latitude,
          "longitude": longitude,
          "pageid": myPageData.PageId,
          "pid": myPageData.Pid
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {

    }
  });
}

function wxShare() {
  // alert(shareLink);
  if (myPageData.PageId) {
    var data = {
      openid: myTemp.openid,
      pageid: myPageData.PageId,
      refereeopenid: myTemp.refereeopenid
    };
    if (myTemp.psn) {
      data.psn = myTemp.psn;
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=share",
      data: data,
      complete: function () {
      }
    });

    var shareLibOption = {
      pageid: parseInt(myPageData.PageId),
      openid: myTemp.openid,
      passport: myTemp.passport,
      apiurl: api.wx.replace("?", ""),
      refereeopenid: myTemp.refereeopenid,
    }
    if (myPageData.Showsharepage == 1) {
      ShareLibSDK.showShareWin(shareLibOption)
    }
    biz.handlerYqAnalyticsEvent('share')
  }
}

var isSendClientInfo = 0;
function sendClientInfo() {
  if (myPageData.PageId) {
    var formater = new UAFormat();
    var formaterResult = formater.getResult();
    var mobileModel = formaterResult.device.model;
    var mobileVendor = formaterResult.device.vendor;
    var mobileType = formaterResult.device.type;
    if (mobileModel == "iPhone") {
      mobileModel = MobileDevice.getModels().join(' or ');
      // iPhone X、iPhone XS
      var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
      // iPhone XS Max
      var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
      // iPhone XR
      var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
      if (isIPhoneX) {
        mobileModel = 'iPhone X';
      }
      if (isIPhoneXSMax) {
        mobileModel = 'iPhone XS Max';
      }
      if (isIPhoneXR) {
        mobileModel = 'iPhone XR';
      }
    } else if (mobileModel == "unknown") {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 || u.indexOf('Adr') > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        mobileType = 'mobile'
        var sss = u.split(";");
        for (var k = 0; k < sss.length; k++) {
          if (sss[k].indexOf("Build/") > -1) {
            mobileModel = sss[k].split("Build/")[0]
            mobileVendor = '';
          }
        }
      }
      else if (isIOS) {
        mobileType = 'ios mobile'
      } else {
        mobileType = 'Browser'
      }
    }
    if (mobileVendor.indexOf("ZTE ") > -1) {
      mobileVendor = "ZTE";
    }
    var data = {
      info: wj.clientInfo,
      pageid: myPageData.PageId,
      refereeopenid: myTemp.refereeopenid,
      model: mobileModel,
      vendor: mobileVendor,
      type: mobileType,
      openid: myTemp.openid,
    };
    if (myTemp.psn) {
      data.psn = myTemp.psn;
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=mt",
      data: data,
      complete: function () {
        isSendClientInfo = 1;
        clearInterval(intervalClientInfo);
      }
    });
    if (mobileModel.indexOf("iPhone X") > -1) {
      $(".page .bottom").css("padding-bottom", "0.5rem");
    }
  }
}
var intervalClientInfo = setInterval(function () {
  if (isSendClientInfo == 0) {
    sendClientInfo();
  }
}, 1000);

function getCount() {
  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbH5Action/pageCounter",
        "requestParam": {
          obj: {
            "id": parseInt(myPageData.PageId)
          }
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      if (data && data.obj && data.obj.length > 0) {
        var countShares = 0;
        var countPv = 0;
        data.obj.forEach(function (item) {
          if (item.type == "shares") {
            countShares = item.count;
          } else if (item.type == "pv") {
            countPv = item.count;
          }
        })
        if (myPageData.Showpv && myPageData.Showpv == 1) {
          $(".count_pv span").text("阅读" + countPv + "次")
          $(".count_pv").removeClass("hide")
        }
        if (myPageData.Showshares && myPageData.Showshares == 1) {
          $(".count_shares span").text("分享" + countShares + "次")
          $(".count_shares").removeClass("hide")
        }
      }
    }
  });
}

function wiseSendParam(param) {
  console.log(param)
}

$(function () {

  if (wj.browser.versions.ios) {
    if (myPageData.PageId == 3570) {
      location.href = "https://www.koalaknow.com/VCharClassic.html?uid=651";
    }
    if (myPageData.PageId == 4515) {
      location.href = "https://www.koalaknow.com/VCharClassic.html?uid=651";
    }
  }
});


(function () {

  var appUserCard = {
    cookieKeys: {
      cardid: "usercard2_cardid",
      uuid: "usercard2_uuid",
      masteropenid: "usercard2_masteropenid",
      projectid: "usercard2_projectid"
    },
    cookieDuration: 60 * 3,
    logInfo: {
      cardid: '',
      uuid: '',
      masteropenid: '',
      projectid: '',
    }
  }
  initUserCard();
  function initUserCard() {
    appUserCard.logInfo.cardid = wj.cookie.get(appUserCard.cookieKeys.cardid);
    appUserCard.logInfo.uuid = wj.cookie.get(appUserCard.cookieKeys.uuid);
    appUserCard.logInfo.masteropenid = wj.cookie.get(appUserCard.cookieKeys.masteropenid);
    appUserCard.logInfo.projectid = wj.cookie.get(appUserCard.cookieKeys.projectid);
    if (appUserCard.logInfo.cardid && appUserCard.logInfo.uuid && appUserCard.logInfo.masteropenid && appUserCard.logInfo.projectid) {
      userCardLog();
      setInterval(userCardLog, 5000);
    }

  }
  function userCardLog() {
    $.ajax({
      type: "GET",
      url: api.wx,
      data: {
        j: JSON.stringify({
          "action": "/electroniccard/ElectronicCardAction/saveCardLog",
          "requestParam": {
            obj: {
              cardid: appUserCard.logInfo.cardid,//电子名片模板id
              uuid: appUserCard.logInfo.uuid,//前端生成的唯一标识
              masteropenid: appUserCard.logInfo.masteropenid,//当前电子名片所属人的openid
              projectid: appUserCard.logInfo.projectid,
              referenceopenid: myTemp.refereeopenid
            }
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {

      }
    });
  }
})();


// 内容自行动
function setContentSelf() {

  let self_action_time = 15;//15秒 3的倍数
  let self_action_count = 0;//当前计时时长
  // 先判断是否开启内容自行动
  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/sales/pageselfconfig/getPageSelfConfig",
        "requestParam": {
          obj: {
            pageid: myPageData.PageId
          }
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      if (data) {
        if (wj.isObject(data.obj)) {
          initSelf();
        }
      }
    }
  });

  function initSelf() {
    let zxdObj = wj.cookie.get("t1_20180910_self_" + myPageData.PageId);
    if (zxdObj) {
      // 如果打开过就显示小球,开启计时器等待参数初始化完成
      let tmpInterval = setInterval(function () {
        if (myPageData.PageId && myTemp.openid && myTemp.passport && myTemp.consultingLink) {
          setShareLibSDK(1);
          clearInterval(tmpInterval);
        }
      }, 100)
    } else {
      // 开启计时器
      let tmpInterval = setInterval(function () {
        self_action_count++;
        if (self_action_count == self_action_time && myPageData.PageId && myTemp.openid && myTemp.passport && myTemp.consultingLink) {
          setShareLibSDK(0);
          wj.cookie.set("t1_20180910_self_" + myPageData.PageId, "true", 365 * 24 * 60 * 60);
          clearInterval(tmpInterval);
        }
      }, 1000)
    }
  }

  function setShareLibSDK(type) {
    if (type == 0) {
      // 播放声音
      window.ContentSelfAudio && window.ContentSelfAudio.play();
    }
    if (myPageData.PageId && myTemp.openid && myTemp.passport && myTemp.consultingLink) {
      let option = {
        pageid: myPageData.PageId,
        openid: myTemp.openid,
        refereeopenid: myTemp.refereeopenid,
        passport: myTemp.passport,
        chaturl: myTemp.consultingLink,
        apiurl: api.wx
      }
      if (type == 1) {
        option.type = 1;
      }
      // 在有rscuid的情况把rscuid当成refereeopid传进来，不传链接上的refereeopenid参数
      if (myTemp.rscuid) {
        option.refereeopenid = myTemp.rscuid
      }
      ShareLibSDK.showPageSelfConfig(option)
    }
  }

}
function checkIsHaveOldMp() {
  /**
   * 悦房云 yuefangy
   * 江西万科 jxwk
   * 安联e家 alej
   * 正宏置业 zhzy
   * 联实 lianshi
   * 原圈云
   */
  var domainList = [
    // "yuefangy",
    // "jxwk",
    // "alej",
    // "zhzy",
    // "lianshi"
    // "yuanquan"
  ];
  var isHave = false;
  domainList.forEach(function (item) {
    if (location.host.indexOf(item + ".") > -1) {
      isHave = true;
    }
  })
  return isHave;
}
(function () {
  // 首页按钮逻辑
  if (myTemp.entry == "zxslzx" && myTemp.t9id && myTemp.t9psn) {
    // 在线售楼中心
    $(".btn_home img").attr("src", "https://assets.rurushishi.com/yq-rs-make/components/btn_home/home2.png?x-oss-process=image/resize,h_100,w_100")
    $(".btn_home").removeClass("hide");
    $(".btn_home").on("click", function () {
      let url = location.protocol + "//" + location.host + "/h5/t9";
      url += "?id=" + myTemp.t9id;
      url += "&psn=" + myTemp.t9psn;
      if (myTemp.refereeopenid) {
        url += "&refereeopenid=" + myTemp.refereeopenid;
      }
      if (myTemp.rscuid) {
        url += "&rscuid=" + myTemp.rscuid;
      }
      wj.getismp(function (ismp) {
        if (ismp && !checkIsHaveOldMp()) {
          wj.mp.rel("/pages/webview/common/common?url=" + encodeURIComponent(url));
        } else {
          location.href = url;
          return false;
        }
      })
    })
  } else if (location.host.indexOf("rywlkj.") > -1) {
    // 润亿网络科技
    wj.getismp(function (ismp) {
      if (ismp) {
        // 我要看房 小程序
        $(".btn_home").removeClass("hide");
        $(".btn_home").on("click", function () {
          wj.mp.switch("/pages/rs/index/index");
        });
      }
    })
  } else if (location.host.indexOf("shxyh.") > -1) {
    // 上海星悦会
    wj.getismp(function (ismp) {
      if (ismp) {
        // 星盟Starunion 小程序
        $(".btn_home").removeClass("hide");
        $(".btn_home").on("click", function () {
          wj.mp.red("/pages/rs/index/index");
        });
      }
    })
  } else if (myTemp.entry == "tyzx") {
    // 在线体验中心
    if (location.host.indexOf("lianshi.") > -1 && myTemp.homeurl) {
      $(".btn_home img").attr("src", "http://rs.static.quanc.com.cn/lsplatform/backIndex.png")
      $(".btn_home").removeClass("hide");
      $(".btn_home").on("click", function () {
        location.href = decodeURIComponent(myTemp.homeurl);
      })
    }
  }
})();

/**
 * @param {object} param  id 页面id number，name 页面名称 string
 */
function loadNewPage(param) {
  myTemp.loadNewPageGuid = wj.getGuid();
  myTemp.loadNewPageParam = param;
  if (myTemp.loadNewPageInterval) {
    clearInterval(myTemp.loadNewPageInterval);
  }
  setTimeout(function () {
    countPagenoTime();
    myTemp.loadNewPageInterval = setInterval(() => {
      countPagenoTime();
    }, 3000);
  }, 1000)
}

function countPagenoTime() {
  let data = {
    pageid: myPageData.PageId,
    pageno: myTemp.loadNewPageParam.id,
    pagename: myTemp.loadNewPageParam.name,
    timelength: 3,
    refereeopenid: myTemp.refereeopenid,
    openid: myTemp.openid,
    tempid: myTemp.loadNewPageGuid
  };
  if (myTemp.psn) {
    data.psn = myTemp.psn;
  }
  if (myTemp.rscuid) {
    data.rscuid = myTemp.rscuid;
  }
  if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
  $.ajax({
    type: "POST",
    url: api.h5 + "act=pageno",
    data: data
  });

}

(function () {
  window.addEventListener("message", function (e) {
    if (e.data) {
      if (e.data.action == "openLocation" && e.data.data) {
        wx.openLocation(e.data.data);
      } else if (e.data.action == "needAuthPhone" && e.data.data) {
        console.log("收到needAuthPhone message，在小程序中将跳转到授权页面，之后将打开", e.data.data.afterAuthWillOpenUrl || location.href)
        // 模拟 景尚中海上东区 点击全景沙盘和户型鉴赏
        // https://zhsd.gbtse.com/h5/tp1.html?id=171561&psn=a053fa0b8b5640d7823b6d8520c56e68&noguide=1
        wj.getismp(function (ismp) {
          if (ismp) {
            var url = e.data.data.afterAuthWillOpenUrl || location.href;
            url = url.replace("#wechat_redirect", "");
            url = wj.addUrlParamFromObj(url, {
              needauth: 'phone'
            })
            var urlParam = wj.getParamFromUrl(url);
            urlParam.j && delete urlParam.j;
            url = wj.addUrlParamFromObj(wj.getUrlRemoveParams(url), urlParam);
            wj.mp.red("/pages/webview/common/common?url=" + encodeURIComponent(url));
          }
        })
      } else if (e.data.action == "connVrSuccess") {
        if (myTemp.vrfid) {
          // 销售
          $(".btn_vr_close").removeClass('hide');
        } else {
          // 用户
          $(".my_indicator").addClass('hide');
          $(".btn_vr_call").addClass('hide');
          $(".btn_vr_close").removeClass('hide');
        }
      } else if (e.data.action == "connClose") {
        window.clickVrClose();
      } else if (e.data.action == 'getIsSubscribe') {
        wj.getFansInfo(function (res) {
          if (res.code == 0) {
            window.frames[0].postMessage({
              callbackId: e.data.callbackId,
              data: res.issubscribe
            }, "*")
          }
        }, myTemp.openid);
      } else if (e.data.action == 'postPhone') {
        if (e.data.data && e.data.data.phone) {
          actEntry(e.data.data.phone, 'sdk', function (res) {
            window.frames[0].postMessage({
              callbackId: e.data.callbackId,
              data: res
            }, "*")
          })
        } else {
          window.frames[0].postMessage({
            callbackId: e.data.callbackId,
            data: '缺少参数:phone'
          }, "*")
        }
      } else if (e.data.action == 'getUserInfo') {
        wj.getFansInfo(function (res) {
          console.log(111, 'iframe message', 'getUserInfo', 'getFansInfo', res)
          window.frames[0].postMessage({
            callbackId: e.data.callbackId,
            data: {
              openid: res.obj.openid,
              nickname: res.obj && (res.obj.ui_name || res.obj.name || res.obj.nickname) || '',
              headimg: res.obj && (res.obj.ui_headimg || res.obj.headimgurl) || '',
              phone: res.obj && (res.obj.ui_mobile || res.obj.mobile) || ''
            }
          }, "*")
        }, myTemp.openid)

      } else if (e.data.action == 'getPageInfo') {
        window.frames[0].postMessage({
          callbackId: e.data.callbackId,
          data: {
            pageId: parseInt(myPageData.PageId)
          }
        }, "*")
      } else if (e.data.action == 'setShare') {
        if (e.data.data && (e.data.data.title || e.data.data.desc || e.data.data.img || e.data.data.linkParams)) {
          initWXJSSDK(e.data.data.title, e.data.data.desc, e.data.data.img, e.data.data.linkParams)
          window.frames[0].postMessage({
            callbackId: e.data.callbackId,
            data: 1
          }, "*")
        } else {
          window.frames[0].postMessage({
            callbackId: e.data.callbackId,
            data: '请至少配置一个参数'
          }, "*")
        }
      } else if (e.data.action == 'loadNewPage') {
        if (e.data.data && e.data.data.id && e.data.data.name) {
          loadNewPage(e.data.data);
          window.frames[0].postMessage({
            callbackId: e.data.callbackId,
            data: 1
          }, "*")
        } else {
          window.frames[0].postMessage({
            callbackId: e.data.callbackId,
            data: '缺少参数id或name'
          }, "*")
        }
      } else if (e.data.action == 'showQrcode') {
        window.showQrcode(e.data.data);
      } else if (e.data.action == "getLocation") {
        if (wj.browser.versions.wx) {
          wx.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              window.frames[0].postMessage({
                callbackId: e.data.callbackId,
                data: res
              }, "*")
            },
            fail: function () {
              window.frames[0].postMessage({
                callbackId: e.data.callbackId
              }, "*")
            }
          });
        } else {
          window.frames[0].postMessage({
            callbackId: e.data.callbackId,
            data: {
              err: '非微信环境下不能获取'
            }
          }, "*")
        }
      } else if (e.data.action == 'wxMiniProgram') {
        if (!(e.data.data && e.data.data.funName && e.data.data.funParam)) {
          window.frames[0].postMessage({
            callbackId: e.data.callbackId,
            data: '缺少参数funName或funParam'
          }, "*")
          return;
        }

        if (!(e.data.data.funName == 'navigateTo' ||
          e.data.data.funName == 'navigateBack' ||
          e.data.data.funName == 'switchTab' ||
          e.data.data.funName == 'reLaunch' ||
          e.data.data.funName == 'redirectTo')) {
          window.frames[0].postMessage({
            callbackId: e.data.callbackId,
            data: 'funName值只能为navigateTo、navigateBack、switchTab、reLaunch和redirectTo'
          }, "*")
          return;
        }
        wx.miniProgram[e.data.data.funName](e.data.data.funParam);
        window.frames[0].postMessage({
          callbackId: e.data.callbackId,
          data: 1
        }, "*")
      } else if (e.data.action == 'setBgMusicIconImgUrl') {
        $(".music_img").attr("src", e.data.data)
        window.frames[0].postMessage({
          callbackId: e.data.callbackId,
          data: 1
        }, "*")
      } else if (e.data.action == 'hdieBgMusicIcon') {
        $(".music").addClass("hide");
        window.frames[0].postMessage({
          callbackId: e.data.callbackId,
          data: 1
        }, "*")
      } else if (e.data.action == 'showBgMusicIcon') {
        $(".music").removeClass("hide");
        window.frames[0].postMessage({
          callbackId: e.data.callbackId,
          data: 1
        }, "*")
      } else if (e.data.action == 'bgMusicPlay') {
        if (myTemp.audio) {
          myTemp.audio.play();
          $(".music_img").addClass("music_img_play");
          window.frames[0].postMessage({
            callbackId: e.data.callbackId,
            data: 1
          }, "*")
        }
      } else if (e.data.action == 'bgMusicPause') {
        if (myTemp.audio) {
          myTemp.audio.pause();
          $(".music_img").removeClass("music_img_play");
          window.frames[0].postMessage({
            callbackId: e.data.callbackId,
            data: 1
          }, "*")
        }
      } else if (e.data.action == 'showVrdkBtn') {
        if (myTemp.rscuid) {
          $(".btn_vr_call").removeClass("hide");
        }
      } else if (e.data.action == 'hideVrdkBtn') {
        $(".btn_vr_call").addClass("hide");
      }
    }
  }, false);
})();

(function () {
  // 小程序与公众号绑定
  if (myTemp.xcxuid && myTemp.xcxappid && myTemp.xcxprojectid && myTemp.appid && myTemp.openid && myTemp.passport) {
    $.ajax({
      type: "post",
      url: "https://wxmp.ruthus.com/api/v1/open/bindRsGzhinfo",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      data: {
        uid: myTemp.xcxuid,
        appid: myTemp.xcxappid,
        projectid: myTemp.xcxprojectid,
        gzhAppid: myTemp.appid,
        gzhOpenid: myTemp.openid,
        gzhPassport: myTemp.passport
      },
      success: function (data) {
        console.log("bindRsGzhinfo", data)
      }
    });
  }
})();

(function () {
  // 提交小程序信息
  if (myTemp.purephonenumber || myTemp.xcxnickname || myTemp.xcxheadimg || myTemp.xcxcountry || myTemp.xcxprovince || myTemp.xcxcity) {
    if (wj.browser.versions.wx && !myTemp.openid) {
      // 如果在微信环境下没有openid就return掉
      return;
    }
    var postObj = {
      pageid: myPageData.PageId,
      psn: myTemp.psn,
      channelid: 0,
      refereeopenid: myTemp.refereeopenid,
      openid: myTemp.openid,
      purpose: 2
    }
    if (myTemp.purephonenumber) {
      postObj.phone = myTemp.purephonenumber;
      yqAnalytics.setUserInfo({
        openId: myTemp.openid,
        phoneNumber: myTemp.purephonenumber
      })
      biz.handlerYqAnalyticsEvent('mpPhoneNumber', {
        phoneNumber: myTemp.purephonenumber
      })
      biz.handlerYqAnalyticsEvent('entryPhoneNumber', {
        phoneNumber: myTemp.purephonenumber,
        type: 10
      })
    }
    if (myTemp.xcxnickname) {
      postObj.nickname = decodeURIComponent(myTemp.xcxnickname);
    }
    if (myTemp.xcxheadimg) {
      postObj.headimg = decodeURIComponent(myTemp.xcxheadimg);
    }
    if (myTemp.xcxcountry) {
      postObj.country = decodeURIComponent(myTemp.xcxcountry);
    }
    if (myTemp.xcxprovince) {
      postObj.province = decodeURIComponent(myTemp.xcxprovince);
    }
    if (myTemp.xcxcity) {
      postObj.city = decodeURIComponent(myTemp.xcxcity);
    }
    if (myTemp.rscuid) {
      postObj.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) postObj.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=entry",
      data: postObj,
      success: function () {
        console.log("小程序提交信息成功")
      }
    });
  }
})();


function showSalePanel() {

  let paramData = null
  // 景尚中海上东区生成销售个人小程序码
  if (myPageData.OriginalUrl && myPageData.OriginalUrl.indexOf("/web/zhonghai-sdqM/") > -1) {
    paramData = {
      isHyaline: "1",
      appid: '8aa3b20276794c74bc7d40762450e652',
      page: 'pages/webview/common/common',
      scene: JSON.stringify({
        pid: 'e4690ea969be4930a8edfa0c8efdc56e',
        url: encodeURIComponent(`https://zhsd.gbtse.com/h5/tp1.html?id=171561&psn=a053fa0b8b5640d7823b6d8520c56e68&refereeopenid=${myTemp.openid}&rscuid=${myTemp.openid}`)
      })
    }
  } else if (wj.subDomain == 'dhbhyh' && myPageData.PageId == 181429) {
    paramData = {
      isHyaline: "1",
      appid: '4ad1422fc14a4325ab9b741a334c239f',
      page: 'pages/webview/common/common',
      scene: JSON.stringify({
        pid: 'd05b82b5a2944a8b92fe203c34597592',
        url: encodeURIComponent(`https://dhbhyh.gbtse.com/h5/tp1.html?id=181429&psn=ab8c699f862e42b5af7fa2ae34cd9c6a&refereeopenid=${myTemp.openid}&rscuid=${myTemp.openid}`)
      })
    }
  } else if (wj.subDomain == 'xyzsplf' && myPageData.PageId == 317510) {
    paramData = {
      isHyaline: "1",
      appid: '9a76c602125e408084e702a4610b5823',
      page: 'pages/webview/common/common',
      scene: JSON.stringify({
        pid: 'b35d09f78ed74f6db682fb7b2766475d',
        url: encodeURIComponent(`https://xyzsplf.okjedi.com/h5/tp1.html?id=317510&psn=2bd6584150c644a59d64b4aa06247a07&refereeopenid=${myTemp.openid}&rscuid=${myTemp.openid}`)
      })
    }
  } else if (wj.subDomain == 'vretk' && myPageData.PageId == 304361) {
    paramData = {
      isHyaline: "1",
      appid: 'bd9a3d84515541fc97f476a270bcdf40',
      page: 'pages/webview/common/common',
      scene: JSON.stringify({
        pid: '58eee8edf3604ed3a1e8fc946f6df42e',
        url: encodeURIComponent(`https://vretk.gdsmcc.com/h5/tp1.html?id=304361&psn=c2654c4f1f864f028b5a4b0f638b8e82&refereeopenid=${myTemp.openid}&rscuid=${myTemp.openid}`)
      })
    }
  } else if (wj.subDomain == 'jzbgyjx' && (myPageData.PageId == 183947 || myPageData.PageId == 181718 || myPageData.PageId == 183944)) {
    paramData = {
      isHyaline: "1",
      appid: '23a970874d5042ba862a5602c07ef230',
      page: 'pages/webview/common/common',
      scene: JSON.stringify({
        pid: 'f5414c4fc771445f96163ee31323ea9a',
        url: encodeURIComponent(`https://jzbgyjx.gdsmcc.com/h5/tp1.html?id=${myPageData.PageId}&psn=${myTemp.psn}&refereeopenid=${myTemp.openid}&rscuid=${myTemp.openid}`)
      })
    }
  } else if (wj.subDomain == 'qmyx' && myPageData.PageId == 169797) {
    paramData = {
      isHyaline: "1",
      appid: '5d4e73d85a514a4f9bcddc4a5c826ce8',
      page: 'pages/webview/common/common',
      scene: JSON.stringify({
        pid: 'bd07d842b1f849e197ff744209ebf900',
        url: encodeURIComponent(`https://qmyx.putzip.com/h5/tp1.html?id=${myPageData.PageId}&psn=${myTemp.psn}&refereeopenid=${myTemp.openid}&rscuid=${myTemp.openid}`)
      })
    }
  } else if ((wj.subDomain == 'jdrcff' && myPageData.PageId == 298229)) {
    let sceneObj = {
      pid: 'e016c4bffeee4cb68345a127229b840b',
      url: encodeURIComponent(`https://${location.host}/h5/tp1.html?id=${myPageData.PageId}&psn=${myTemp.psn}&refereeopenid=${myTemp.openid}&rscuid=${myTemp.openid}`)
    };
    if (myTemp.xcxuid) {
      sceneObj.fuid = myTemp.xcxuid;
      sceneObj.ouid = myTemp.xcxuid;
    }
    paramData = {
      isHyaline: "1",
      appid: '1240b9e052b64124bbb8b6ea1a336ac6',
      page: 'pages/webview/common/common',
      scene: JSON.stringify(sceneObj)
    }
  } else if (wj.subDomain == 'dljdpp' && myTemp.isQuestionnaire && myPageData.PageId == 293914) {
    let sceneObj = {
      pid: '06fda2dbf4aa4f75b5a02ceebae195d8',
      url: encodeURIComponent(`https://${location.host}/h5/tp1.html?id=${myPageData.PageId}&psn=${myTemp.psn}&refereeopenid=${myTemp.openid}&rscuid=${myTemp.openid}`)
    };
    if (myTemp.xcxuid) {
      sceneObj.fuid = myTemp.xcxuid;
      sceneObj.ouid = myTemp.xcxuid;
    }
    paramData = {
      isHyaline: "1",
      appid: 'e036142846d14587885156caa8694ace',
      page: 'pages/webview/common/common',
      scene: JSON.stringify(sceneObj)
    }
  } else if (wj.subDomain == 'dljdpp' && myTemp.isQuestionnaire && (myPageData.PageId == 312413 || myPageData.PageId == 312676
    || myPageData.PageId == 312675 || myPageData.PageId == 312674 || myPageData.PageId == 312673 || myPageData.PageId == 312672)) {
    let sceneObj = {
      pid: '0512f15a5261495e9e25abed9a154d27',
      url: encodeURIComponent(`https://${location.host}/h5/tp1.html?id=${myPageData.PageId}&psn=${myTemp.psn}&refereeopenid=${myTemp.openid}&rscuid=${myTemp.openid}`)
    };
    if (myTemp.xcxuid) {
      sceneObj.fuid = myTemp.xcxuid;
      sceneObj.ouid = myTemp.xcxuid;
    }
    paramData = {
      isHyaline: "1",
      appid: '607f06c921884a9e927fa45a6a6bfaf4',
      page: 'pages/webview/common/common',
      scene: JSON.stringify(sceneObj)
    }
  } else if (wj.subDomain == 'dljdpp' && myTemp.isQuestionnaire && [290778, 290907, 290912, 290929, 290931, 290932, 290933, 290934, 290935, 290936,
    290937, 290921, 290917, 290922, 290910, 290923, 290926, 290908, 290918, 290927, 290909, 290913, 290914, 290915, 290928, 290920, 290925, 290919,
    290916, 290924, 290911].includes(parseInt(myPageData.PageId))) {
    let sceneObj = {
      pid: '5fd19c45e26742dea94810c5ad74bf75',
      url: encodeURIComponent(`https://${location.host}/h5/tp1.html?id=${myPageData.PageId}&psn=${myTemp.psn}&refereeopenid=${myTemp.openid}&rscuid=${myTemp.openid}`)
    };
    if (myTemp.xcxuid) {
      sceneObj.fuid = myTemp.xcxuid;
      sceneObj.ouid = myTemp.xcxuid;
    }
    paramData = {
      isHyaline: "1",
      appid: 'af94e0dacb324d45bd0bb9d521b4629a',
      page: 'pages/webview/common/common',
      scene: JSON.stringify(sceneObj)
    }
  }

  // 生成销售个人小程序码 https://qqkj.zentaopm.com/story-view-1010.html
  console.log('isale', myTemp.isSale);
  if (paramData && myTemp.isSale) {
    $(".btn_qrcode").removeClass("hide");
    if (cfg.isLoc) {
      // 本地不能点击所以直接生成用于快速开发
      showXcxCode();
    }
    $(".btn_qrcode").on("click", function () {
      showXcxCode();
    })
    function showXcxCode() {
      if (myTemp.myXcxCode) {
        wx.previewImage({
          current: myTemp.myXcxCode,
          urls: [myTemp.myXcxCode]
        })
        return;
      }
      $.ajax({
        type: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        url: "https://wxmp.ruthus.com/api/v1/open/wx/acode",
        data: paramData,
        success: function (res) {
          if (res && res.data) {
            myTemp.myXcxCode = res.data;
            wx.previewImage({
              current: myTemp.myXcxCode,
              urls: [myTemp.myXcxCode]
            })
          }
        }
      });
    }
  }

  if (!myTemp.isSale) {
    // 非销售
    // 景尚 东华滨湖壹号院 有传播者信息 显示呼叫按钮
    if (location.host.indexOf("dhbhyh.") > -1 || location.host.indexOf("vretk.") > -1 || myPageData.PageId == 317510 || location.host.indexOf("localhost") > -1) {
      if (myTemp.rscuid) {
        $(".btn_vr_call").removeClass("hide");
      }
    }
  }

  $(".btn_vr_call img").on("click", function () {
    // 拼接发送模板消息通知的链接
    (function () {
      var url = "";
      var newUrlParam = wj.getParamFromUrl(location.href);

      if (newUrlParam.j) delete newUrlParam.j;
      if (newUrlParam.xcxuid) delete newUrlParam.xcxuid;
      if (newUrlParam.xcxappid) delete newUrlParam.xcxappid;
      if (newUrlParam.xcxprojectid) delete newUrlParam.xcxprojectid;
      if (newUrlParam.purephonenumber) delete newUrlParam.purephonenumber;
      if (newUrlParam.xcxnickname) delete newUrlParam.xcxnickname;
      if (newUrlParam.xcxheadimg) delete newUrlParam.xcxheadimg;
      if (newUrlParam.xcxcountry) delete newUrlParam.xcxcountry;
      if (newUrlParam.xcxprovince) delete newUrlParam.xcxprovince;
      if (newUrlParam.xcxcity) delete newUrlParam.xcxcity;

      newUrlParam.refereeopenid = myTemp.openid;
      if (newUrlParam.rscuid) {
        delete newUrlParam.rscuid;
      }
      newUrlParam.vrfid = myTemp.openid;
      newUrlParam.opentrtcroom = 1;
      newUrlParam.backhome = "home";
      if (cfg.isLoc) {
        var tmpUrl = location.href;
        tmpUrl = tmpUrl.replace("localhost:2000/gong/yuanquan/yq-rs-h5/src/", "yuanquan.gbtse.com/h5/");
        url = wj.addUrlParamFromObj(wj.getUrlRemoveParams(tmpUrl), newUrlParam);
      } else {
        url = wj.addUrlParamFromObj(wj.getUrlRemoveParams(location.href), newUrlParam);
      }
      url = "pages/webview/common/common?url=" + encodeURIComponent(url);
      console.log(" 模板消息链接： " + url);
      window.frames[0].postMessage({
        action: 'pageop_clickvoice',
        data: url,
      }, "*")
      $(".my_indicator").removeClass('hide');
      var strMsg = "您收到了客户的VR带看请求！";
      if (myTemp.userInfo) {
        strMsg = "您收到了客户" + myTemp.userInfo.user.nickname + "的VR带看请求！";
      }
      var gzhMpAppId = {
        'wx01f0b018d4951434': 'wx28643e3557718b2f',//很多奖，看好房子
        'wxd4c280bb15760f39': 'wx28643e3557718b2f',//原圈云，看好房子
        'wx449aabdf601a18a9': 'wx84f79b5372f65f7c',//联实，联实逸浦荟线上服务中心
        'wx595cc0073a2d14ac': 'wxf82acab534d9eeee',//景尚 中车花溪镇二期，中车花溪镇二期线上售楼处
        "wx1674850d434d8e38": 'wx62dd64828c351116',// 景尚 东华滨湖壹号院，滨湖壹号院
        "wx79c16573890a7658": 'wx9b669b913215a6d3',// 景尚 VRE拓客 贵阳万达广场
        "wxd527cb0af3407a17": 'wxdbd197c3c7183774',// 景尚 象屿招商蟠龙府 象屿招商蟠龙府
      };
      var requestParam = {
        title: "VR带看请求",
        content: strMsg,
        nickname: myTemp.cardInfo.user.name,
        url: url,
        openid: myTemp.cardInfo.user.openid,
        miniappid: gzhMpAppId[myTemp.cardInfo.user.appid],
        minipagepath: url,
        targetOpenid: myTemp.cardInfo.user.openid,
        sms: strMsg
      };
      wj.sendCommonTmpMsg(requestParam, function () {

      });
      window.frames[0].postMessage({
        action: 'btn_vr_call',
        data: url,
      }, "*")
    })();

  })
  $(".btn_vr_close img").on("click", function () {
    window.clickVrClose('userClick');
  })
  $(".my_indicator .close img").on("click", function () {
    $(".my_indicator").addClass("hide");
    window.clickVrClose('userClick');
  })
  window.clickVrClose = function (typeFrom) {
    if (myTemp.vrfid) {
      // 销售
      $(".btn_vr_close").addClass('hide');
    } else {
      // 用户
      $(".btn_vr_call").removeClass('hide');
      $(".btn_vr_close").addClass('hide');
    }
    if (typeFrom == 'userClick') {
      window.frames[0].postMessage({
        action: 'btn_vr_close',
        data: '',
      }, "*")
    }
  }
}

// (function () {
//   if (wj.qs("j")) {
//     setTimeout(() => {

//       let paramObj = {
//         id: myPageData.PageId,
//         psn: myTemp.psn,
//         refereeopenid: myTemp.refereeopenid || undefined,
//         rscuid: myTemp.rscuid || undefined,
//         vrfid: myTemp.vrfid || undefined,
//         extpar: myTemp.extpar || undefined
//       }
//       let newObj = {}
//       Object.keys(paramObj).forEach(key => {
//         if (paramObj[key] != undefined) {
//           newObj[key] = paramObj[key]
//         }
//       })
//       paramObj = newObj;

//       window.history.replaceState(null, null, '?' + wj.objToUrlParam(newObj))
//     }, 1000);
//   }
// })();

(function () {
  // window.history.pushState(null, null, window.location.href);
  // var windowHeight = $(window).innerHeight();
  // $("#myFrame").css({
  //   height: windowHeight
  // });

  let tmpInterval3553 = setInterval(() => {
    // if (window.history.length == 2) {
    var windowHeight = $(window).innerHeight();
    // 景尚中海上东区
    if (((myPageData.OriginalUrl && myPageData.OriginalUrl.indexOf("/web/zhonghai-sdqM/") > -1) || myPageData.PageId == 317510 || myPageData.PageId == 181429 || myPageData.PageId == 304361 || myPageData.PageId == 183947 || myPageData.PageId == 181718 || myPageData.PageId == 183944 || (wj.subDomain == 'qmyx' && myPageData.PageId == 169797)) && myTemp.rscuid) {
      $("#myFrame").css({
        height: windowHeight - $(".saler").height()
      });
      $(".page").css({
        height: windowHeight - $(".saler").height()
      })
    } else {
      $("#myFrame").css({
        height: windowHeight
      });
      $(".page").css({
        height: windowHeight
      })
    }
    clearInterval(tmpInterval3553);
    // }
  }, 100);
})();

window.showQrcode = function (data) {
  let qrcodeUrl = '', name = '';
  if (Object.prototype.toString.call(data) === "[object String]") {
    qrcodeUrl = data;
  } else if (Object.prototype.toString.call(data) === "[object Object]" && data.name && data.qrcodeUrl) {
    qrcodeUrl = data.qrcodeUrl;
    name = data.name;
  }
  if (name) {
    $(".wx-qrcode .text").html(name);
  }
  $(".wx-qrcode .qr").attr("src", qrcodeUrl || myPageData.Other.gzh_qrcode);
  $(".wx-qrcode").removeClass("hide");
}
$(".close").on("click", function (e) {
  e.preventDefault();
  $(".wx-qrcode").addClass("hide");
});

// 企业微信功能片
(function () {
  function getMaxYData(cvsImgData) {
    let item = null;
    for (let index = 0; index < cvsImgData.length; index++) {
      if (index < cvsImgData.length - 1) {
        if (cvsImgData[index].y < cvsImgData[index + 1].y) {
          item = cvsImgData[index + 1]
        } else {
          item = cvsImgData[index]
        }
      }
    }
    return item;
  }
  // 如果有企微且配置的企微的开关打开了就展示
  let isOpenQywx = false;
  if (myPageData.Other && myPageData.Other.funcs && myPageData.Other.funcs.length > 0) {
    myPageData.Other.funcs.forEach(item => {
      if (myTemp.bottomBtnCount < 5) {
        let isAdd = false;
        if (item.isvalid == 1) {
          if (item.funcType == "qywx" && item.funcName) {
            isOpenQywx = true;
            isAdd = true;
          } else if (item.funcType == "houseconfig") {
            $(".btn_appointment").css("display", "block");
            let funcData = item.funcData;
            if (Object.prototype.toString.call(funcData) === "[object String]") {
              funcData = JSON.parse(funcData);
            }
            if (funcData.name) {
              $(".btn_appointment .txt").html(funcData.name)
            }
            $(".btn_appointment").on("click", function () {
              let url = funcData.links;
              let addUrlParams = {
                pageid: myPageData.PageId,
                backurl: encodeURIComponent(location.href)
              }
              if (myTemp.refereeopenid) {
                addUrlParams.refereeopenid = myTemp.refereeopenid;
              }
              if (myTemp.rscuid) {
                addUrlParams.rscuid = myTemp.rscuid;
              }
              let urlDomain = url.split("/");
              url = url.replace(urlDomain[2], location.host);
              url = wj.addUrlParamFromObj(url, addUrlParams);
              location.href = url;
            })
            isAdd = true;
          }
          if (isAdd) {
            myTemp.bottomBtnCount++;
          }
        }
      }
    })
  }

  new Promise((resolve, reject) => {

    wj.getUserInfo(function (resUserInfo) {
      // 如果自己是销售 更换rscuid
      if (resUserInfo.obj && resUserInfo.obj.user && resUserInfo.obj.user.cardno) {
        myTemp.rscuid = myTemp.openid;
      }
      if (myTemp.rscuid) {
        if (myTemp.cardFansInfo && myTemp.cardFansInfo.mobile) {
          resolve(myTemp.cardFansInfo);
        } else {
          wj.getFansInfo(function (data) {
            myTemp.cardFansInfo = data.obj;
            resolve(myTemp.cardFansInfo);
          }, myTemp.rscuid)
        }
      } else {
        resolve(null)
      }
    }, myTemp.openid)
  }).then(cardFansInfo => {
    console.log(999, cardFansInfo)
    if (cardFansInfo == null || Object.prototype.toString.call(cardFansInfo) != "[object Object]") {
      return;
    }
    comreq.getExtUserIdByOpenid({
      openid: cardFansInfo.openid,
      accountType: 'qywx',
      projectid: cardFansInfo.projectid
    }).then(res => {
      return new Promise((resolve, reject) => {
        if (res.data && (res.data.userid || res.data.account) && res.data.accountOrgid) {
          comreq.getCorpUserCard({
            corpId: res.data.accountOrgid,
            appMark: window.myTemp.appMark,
            type: 1,
            scene: 2,
            style: 1,
            user: [res.data.userid || res.data.account],
            businessData: {
              sceneCode: "marketing_content"
            },
            projectId: cardFansInfo.projectid
          }).then(res1 => {
            if (res1.data && res1.data.qr_code) {
              myTemp.qwQrCodeUrl = res1.data.qr_code;
              resolve();
            } else {
              reject();
            }
          })
        } else {
          reject();
        }
      }).then(() => {
        if (isOpenQywx) {
          // 生成海报
          let bgWidth = 510;
          let bgHeight = 0;//根据文字高度动态计算
          let sharpness = 2;
          let labelX = 30;
          let baseY = 490;
          let lineHeight = 50 * sharpness;
          let cvsImgData = [
            {
              type: "img",
              zIndex: 2,
              x: 0,
              y: 0,
              width: bgWidth * sharpness,
              height: 458 * sharpness,
              content:
                "https://assets.rurushishi.com/yq-rs-h5/qwqrcode_bg2.png",
            },
            {
              type: "img",
              shape: "", //默认是矩形，  'arc代表画圆'
              zIndex: 3,
              x: ((bgWidth - 300) / 2) * sharpness,
              y: ((458 - 300) / 2) * sharpness,
              width: 300 * sharpness,
              height: 300 * sharpness,
              content: myTemp.qwQrCodeUrl,
            },
            {
              type: "text",
              zIndex: 2,
              x: labelX * sharpness,
              y: baseY * sharpness,
              content: myTemp.cardFansInfo.name,
              fontSize: `${30 * sharpness}px 微软雅黑`,
              color: "#333333",
            },
            {
              type: "text",
              zIndex: 2,
              x: (labelX + wj.getStrBlen(myTemp.cardFansInfo.name) * (30 / 2) + 20) * sharpness,
              y: (baseY + 5) * sharpness,
              content: myTemp.cardFansInfo.mobile,
              fontSize: `${26 * sharpness}px 微软雅黑`,
              color: "#333333",
            },
            {
              type: "text",
              zIndex: 2,
              x: labelX * sharpness,
              y: (baseY + 10) * sharpness + lineHeight,
              content: "楼盘项目:",
              fontSize: `${26 * sharpness}px 微软雅黑`,
              color: "#999999",
            },
            {
              type: "text",
              zIndex: 2,
              x: (labelX + wj.getStrBlen("楼盘项目:") * (30 / 2)) * sharpness,
              y: (baseY + 10) * sharpness + lineHeight,
              content: myTemp.cardFansInfo.projectname,
              fontSize: `${26 * sharpness}px 微软雅黑`,
              color: "#333333",
            }
          ];
          if (myTemp.cardFansInfo.ui_address) {
            let maxYItem = getMaxYData(cvsImgData);
            cvsImgData.push({
              type: "text",
              zIndex: 2,
              x: labelX * sharpness,
              y: maxYItem.y + lineHeight,
              content: "地      址:",
              fontSize: `${26 * sharpness}px 微软雅黑`,
              color: "#999999",
            })

            let tmpStrList = [];
            let tmpStrListIndex = 0;
            let title = myTemp.cardFansInfo.ui_address;

            // title = "一二三四五六七八九十一";
            // title = "一二三四五六七八九十一二三四五六七八九十";
            // title =
            // "一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十";
            for (let index = 0; index < title.length; index++) {
              if (
                tmpStrListIndex == 0 ||
                tmpStrListIndex >= 24 * tmpStrList.length
              ) {
                tmpStrList.push(title[index]);
              } else {
                tmpStrList[tmpStrList.length - 1] += title[index];
              }
              // 处理中英文占的长度
              tmpStrListIndex += wj.getStrBlen(title[index]);
            }
            let stringYStartValue = maxYItem.y + lineHeight;
            // 最多展示三行
            // if (tmpStrList.length > 3) {
            //   tmpStrList = tmpStrList.slice(0, 3);
            // }
            let stringX = labelX + wj.getStrBlen("一二三四:") * (30 / 2);
            for (let index = 0; index < tmpStrList.length; index++) {

              let stringY = 0;
              if (tmpStrList.length == 1) {
                // stringX =
                //   60 +
                //   (255 - (this.$util.getStrBlen(tmpStrList[index]) / 2) * 14) / 2; //原本的x值+（方框宽度-字符串宽度）/2 居中的写法
                // stringX = 60;
                stringY = stringYStartValue;
              } else {
                // stringX = 60;
                stringY = stringYStartValue + 40 * sharpness * index;
              }
              let item = {
                type: "text",
                zIndex: 4,
                fontSize: `${26 * sharpness}px 微软雅黑`,
                x: stringX * sharpness,
                y: stringY,
                content: tmpStrList[index],
                color: "#333333",
              };
              cvsImgData.push(item);
            }
          }
          if (myTemp.cardFansInfo.ui_personalprofile) {
            let maxYItem = getMaxYData(cvsImgData);
            cvsImgData.push({
              type: "text",
              zIndex: 2,
              x: labelX * sharpness,
              y: maxYItem.y + lineHeight,
              content: "个性签名:",
              fontSize: `${26 * sharpness}px 微软雅黑`,
              color: "#999999",
            })

            let tmpStrList = [];
            let tmpStrListIndex = 0;
            let title = myTemp.cardFansInfo.ui_personalprofile;

            // title = "一二三四五六七八九十一";
            // title = "一二三四五六七八九十一二三四五六七八九十";
            // title =
            // "一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十";
            for (let index = 0; index < title.length; index++) {
              if (
                tmpStrListIndex == 0 ||
                tmpStrListIndex >= 24 * tmpStrList.length
              ) {
                tmpStrList.push(title[index]);
              } else {
                tmpStrList[tmpStrList.length - 1] += title[index];
              }
              // 处理中英文占的长度
              tmpStrListIndex += wj.getStrBlen(title[index]);
            }
            let stringYStartValue = maxYItem.y + lineHeight;
            // 最多展示三行
            // if (tmpStrList.length > 3) {
            //   tmpStrList = tmpStrList.slice(0, 3);
            // }
            let stringX = labelX + wj.getStrBlen("个性签名:") * (30 / 2);
            for (let index = 0; index < tmpStrList.length; index++) {

              let stringY = 0;
              if (tmpStrList.length == 1) {
                // stringX =
                //   60 +
                //   (255 - (this.$util.getStrBlen(tmpStrList[index]) / 2) * 14) / 2; //原本的x值+（方框宽度-字符串宽度）/2 居中的写法
                // stringX = 60;
                stringY = stringYStartValue;
              } else {
                // stringX = 60;
                stringY = stringYStartValue + 40 * sharpness * index;
              }
              let item = {
                type: "text",
                zIndex: 4,
                fontSize: `${26 * sharpness}px 微软雅黑`,
                x: stringX * sharpness,
                y: stringY,
                content: tmpStrList[index],
                color: "#333333",
              };
              cvsImgData.push(item);
            }
          }
          let maxYItem = getMaxYData(cvsImgData);
          bgHeight = maxYItem.y + 60 * sharpness;
          const cvsimg = new Canvastoimg({
            width: bgWidth * sharpness, //画布宽度
            height: bgHeight, //画布高度
            color: "#ffffff", //画布背景色
            data: cvsImgData,
          });
          cvsimg.down().then((canvas) => {
            /* 获取到的是canvas对象 */
            myTemp.qwQrCodePoster = canvas.toDataURL("image/jpg");
            $(".btn_wxwork").css("display", "block");
            $(".vue_showimg_img").attr("src", myTemp.qwQrCodePoster);
            $(".btn_wxwork").on("click", function (e) {
              $(".vue_showimg").removeClass("hide")
            })
            $(".vue_showimg_close").on("click", function (e) {
              $(".vue_showimg").addClass("hide")
            })
          });
        }
      })
    })
  })
})();

// 绑定微信openid到企微外部联系人帐号
(function () {
  let urlParam = wj.getParamFromUrl(location.href);
  if (urlParam.corpId && urlParam.extAccount && urlParam.fromAccount && urlParam.accountType && myTemp.openid) {
    let postParams = {
      openid: myTemp.openid,
      accountOrgid: urlParam.corpId,
      accountType: urlParam.accountType,
      appType: urlParam.appType == 1 ? 1 : 0,
      extAccount: urlParam.extAccount,
      fromAccount: urlParam.fromAccount
    }
    if (urlParam.hasOwnProperty('cfgId')) {
      postParams.cfgId = urlParam.cfgId;
    }
    if (urlParam.hasOwnProperty('state')) {
      postParams.state = urlParam.state;
    }
    comreq.userAccountBindExternal(postParams);
  }
})();

// 埋点
(function () {
  if (myTemp.openid) {
    yqAnalytics.setUserInfo({
      openId: myTemp.openid
    })
  }
  biz.handlerGetYqAnalyticsPropertyValueBaseData().then(propertyValueBaseData => {
    yqAnalytics.pageOpen({
      pageUrl: propertyValueBaseData.pageUrl,
      propertyValue: JSON.stringify(propertyValueBaseData)
    })
  })
})();

(function () {

  var tempX, x, tempY, y;

  function dragStart(e) {
    tempX = parseInt($(this).css("right") + 0);
    tempY = parseInt($(this).css("top") + 0);
    x = e.touches[0].pageX;
    y = e.touches[0].pageY;
  }

  function dragMove(e) {
    var curX = tempX - e.touches[0].pageX + x;
    var curY = tempY + e.touches[0].pageY - y;
    //边界判断
    curX = curX < 0 ? 0 : curX;
    curY = curY < 0 ? 0 : curY;
    curX = curX < document.body.clientWidth - $(this).width() ? curX : document.body.clientWidth - $(this).width();
    curY = curY < document.body.clientHeight - $(this).height() ? curY : document.body.clientHeight - $(this).height();
    $(this).css({
      "right": curX,
      "top": curY
    });
    //禁止浏览器默认事件
    e.preventDefault();
  }

  function dragEnd() {

  }
  // 传入 classname
  window.SetDragEle = function () {
    if (arguments.length > 0) {
      for (let i = 0; i < arguments.length; i++) {
        let eles = document.getElementsByClassName(arguments[i]);
        if (eles && eles.length > 0) {
          eles[0].addEventListener("touchstart", dragStart);
          eles[0].addEventListener("touchmove", dragMove);
          eles[0].addEventListener("touchend", dragEnd);
        }
      }
    }
  }

  let tmpInterval = setInterval(function () {
    let eles = document.getElementsByClassName('fload-head');
    if (eles && eles.length > 0) {
      window.SetDragEle("fload-head");
      clearInterval(tmpInterval);
    }
  }, 1000)

  window.SetDragEle("btn_luckdraw2");

})();

(function () {
  window.getIPv6 = function (data) {
    console.log('getIPv6', data);
    myTemp.ipv6 = data.ip;
  }
  wj.loadJS("https://api64.ipify.org?format=jsonp&callback=getIPv6", function () {
    console.log('加载ipify')
  })
})();